/**
 * Official theme catalog and helpers — @acv/theme-tokens (single source of truth).
 * Previously: ACV/src/data/themeColors.js
 */

export const themeColorOptions = [
  // CONSERVATIVE / PROFESSIONAL THEMES
  {
    id: "default",
    name: "Default Light",
    description: "Clean and professional light theme",
    family: "conservative",
    colors: {
      primary: "hsl(221.2 83.2% 53.3%)",
      secondary: "hsl(210 40% 96%)",
      accent: "hsl(210 40% 94%)",
      background: "hsl(0 0% 100%)",
      foreground: "hsl(222.2 84% 4.9%)",
      muted: "hsl(210 40% 96%)",
      mutedForeground: "hsl(215.4 16.3% 46.9%)",
      card: "hsl(0 0% 100%)",
      cardForeground: "hsl(222.2 84% 4.9%)",
      border: "hsl(214.3 31.8% 91.4%)",
      navbar: "hsl(0 0% 100%)",
      toolbar: "hsl(210 40% 98%)",
      header: "hsl(221.2 83.2% 53.3%)",
      paper: "hsl(0 0% 100%)",
      footer: "hsl(210 40% 96%)",
      destructive: "hsl(0 84.2% 60.2%)",
      destructiveForeground: "hsl(210 40% 98%)",
      ring: "hsl(221.2 83.2% 53.3%)",
      input: "hsl(214.3 31.8% 91.4%)",
      popover: "hsl(0 0% 100%)",
      popoverForeground: "hsl(222.2 84% 4.9%)",
      // Controls (Barra de Filtros)
      controlsBg: "hsl(0 0% 100%)", // #FAFAFA - Fondo muy suave
      controlsForeground: "hsl(222.2 84% 4.9%)", // Texto principal
      controlsBorder: "hsl(214.3 31.8% 91.4%)", // Borde sutil

      attendanceLateBg: "hsl(258 60% 50%)",
      attendanceLateFg: "hsl(0 0% 100%)",
      attendanceAbsentBg: "hsl(0 84.2% 60.2%)",
      attendanceAbsentFg: "hsl(0 0% 100%)",
      attendancePresentBg: "hsl(221.2 83.2% 53.3%)",
      attendancePresentFg: "hsl(0 0% 100%)",
      attendanceJustifiedBg: "hsl(280 55% 58%)",
    },
  },
  {
    id: "default-dark",
    name: "Default Dark",
    description: "Elegant dark theme optimized for reduced eye strain",
    family: "conservative",
    colors: {
      primary: "hsl(210 90% 65%)",
      secondary: "hsl(215 15% 25%)",
      accent: "hsl(217.2 32.6% 17.5%)",
      background: "hsl(220 10% 8%)",
      foreground: "#ffffff",
      muted: "hsl(217.2 32.6% 17.5%)",
      mutedForeground: "hsl(215 20.2% 65.1%)",
      card: "hsl(220 10% 12%)",
      cardForeground: "#ffffff",
      border: "hsl(215 15% 25%)",
      navbar: "hsl(220 10% 12%)",
      toolbar: "hsl(220 10% 12%)",
      header: "hsl(217.2 91.2% 59.8%)",
      paper: "hsl(222.2 84% 4.9%)",
      footer: "hsl(217.2 32.6% 17.5%)",
      destructive: "hsl(0 62.8% 30.6%)",
      destructiveForeground: "hsl(210 40% 98%)",
      ring: "hsl(217.2 91.2% 59.8%)",
      input: "hsl(217.2 32.6% 17.5%)",
      popover: "hsl(222.2 84% 4.9%)",
      popoverForeground: "hsl(210 40% 98%)",
      // Controls (Barra de Filtros)
      controlsBg: "hsl(220 10% 12%)", // Fondo ligeramente más oscuro
      controlsForeground: "#ffffff", // Texto claro
      controlsBorder: "hsl(215 15% 30%)", // Borde más visible
      // Hover en navbar/toolbar: tono oscuro (mismo H/S, L un poco mayor) para WCAG AA en iconos
      navbarItemHoverBg: "hsl(220 10% 14%)",

      sidebarBg: "hsl(220 10% 9%)",
      cardHoverBg: "hsl(220 10% 15%)",
      cardActiveBg: "hsl(217.2 28% 18%)",
      surfaceHover: "hsl(220 10% 15%)",
      textTertiary: "hsl(220 8% 68%)",
      cardTextColor: "hsl(220 6% 86%)",
      sidebarBorder: "hsl(215 15% 22%)",
      sidebarItemBg: "transparent",
      textSecondary: "hsl(220 6% 86%)",
      cardSelectedBg: "hsl(217.2 32.6% 28%)",
      cardTitleColor: "#ffffff",
      cardHoverBorder: "hsl(215 15% 30%)",
    },
  },
  {
    id: "professional-slate",
    name: "Professional Slate",
    description: "Sophisticated slate theme for corporate environments",
    family: "conservative",
    colors: {
      primary: "hsl(215 25% 27%)",
      secondary: "hsl(215 16% 47%)",
      accent: "hsl(215 20% 65%)",
      background: "hsl(0 0% 100%)",
      foreground: "hsl(215 25% 27%)",
      muted: "hsl(215 20% 65%)",
      mutedForeground: "hsl(215 16% 47%)",
      card: "hsl(0 0% 100%)",
      cardForeground: "hsl(215 25% 27%)",
      border: "hsl(215 20% 65%)",
      navbar: "hsl(0 0% 100%)",
      toolbar: "hsl(215 20% 95%)",
      header: "hsl(215 25% 27%)",
      paper: "hsl(0 0% 100%)",
      footer: "hsl(0 0% 96%)",
      destructive: "hsl(0 84.2% 60.2%)",
      destructiveForeground: "hsl(210 40% 98%)",
      ring: "hsl(215 25% 27%)",
      input: "hsl(215 20% 65%)",
      popover: "hsl(0 0% 100%)",
      popoverForeground: "hsl(215 25% 27%)",
      // Controls (Barra de Filtros)
      controlsBg: "hsl(0 0% 100%)", // #F8F9FA - Fondo muy claro
      controlsForeground: "hsl(215 25% 27%)", // Texto slate oscuro
      controlsBorder: "hsl(215 20% 85%)", // Borde slate suave

      attendanceLateBg: "hsl(258 60% 50%)",
      attendanceLateFg: "hsl(0 0% 100%)",
      attendanceAbsentBg: "hsl(0 84.2% 60.2%)",
      attendanceAbsentFg: "hsl(0 0% 100%)",
      attendancePresentBg: "hsl(215 25% 27%)",
      attendancePresentFg: "hsl(0 0% 100%)",
      attendanceJustifiedBg: "hsl(280 55% 58%)",
      attendanceJustifiedFg: "hsl(0 0% 100%)",
    },
  },
  {
    id: "minimal-gray",
    name: "Minimal Gray",
    description: "Ultra-clean minimal theme with subtle gray tones",
    family: "conservative",
    colors: {
      primary: "hsl(210 30% 45%)",
      secondary: "hsl(210 12% 90%)",
      accent: "hsl(0 0% 94%)",
      background: "hsl(210 15% 92%)",
      foreground: "hsl(210 40% 15%)",
      muted: "hsl(0 0% 96%)",
      mutedForeground: "hsl(0 0% 45%)",
      card: "hsl(210 15% 96%)",
      cardForeground: "hsl(210 40% 15%)",
      border: "hsl(210 12% 85%)",
      navbar: "hsl(210 15% 96%)",
      toolbar: "hsl(210 15% 96%)",
      header: "hsl(0 0% 20%)",
      paper: "hsl(0 0% 100%)",
      footer: "hsl(0 0% 96%)",
      destructive: "hsl(0 84.2% 60.2%)",
      destructiveForeground: "hsl(210 40% 98%)",
      ring: "hsl(0 0% 20%)",
      input: "hsl(0 0% 89%)",
      popover: "hsl(0 0% 100%)",
      popoverForeground: "hsl(0 0% 20%)",
      // Controls (Barra de Filtros)
      controlsBg: "hsl(210 15% 96%)", // #FCFCFC - Fondo casi blanco
      controlsForeground: "hsl(210 40% 15%)", // Texto gris oscuro
      controlsBorder: "hsl(210 12% 80%)", // Borde gris muy suave

      textTertiary: "rgba(90,90,90,0.55)",
      cardTextColor: "rgba(90,90,90,0.72)",
      textSecondary: "rgba(90,90,90,0.72)",
      cardTitleColor: "hsl(210 40% 15%)",
      inputForeground: "hsl(210 40% 15%)",
      navbarIconColor: "hsl(210 40% 15%)",
      tableForeground: "hsl(210 40% 15%)",
      attendanceLateBg: "hsl(258 60% 50%)",
    },
  },
  {
    id: "corporate-blue",
    name: "Corporate Blue",
    description: "Professional blue theme for business environments",
    family: "conservative",
    colors: {
      primary: "hsl(210 100% 40%)",
      secondary: "hsl(210 40% 96%)",
      accent: "hsl(210 40% 94%)",
      background: "hsl(0 0% 100%)",
      foreground: "hsl(210 40% 15%)",
      muted: "hsl(210 40% 96%)",
      mutedForeground: "hsl(210 20% 50%)",
      card: "hsl(0 0% 100%)",
      cardForeground: "hsl(210 40% 15%)",
      border: "hsl(210 40% 90%)",
      navbar: "hsl(0 0% 100%)",
      toolbar: "hsl(210 40% 98%)",
      header: "hsl(210 100% 40%)",
      paper: "hsl(0 0% 100%)",
      footer: "hsl(210 40% 96%)",
      destructive: "hsl(0 84.2% 60.2%)",
      destructiveForeground: "hsl(210 40% 98%)",
      ring: "hsl(210 100% 40%)",
      input: "hsl(210 40% 90%)",
      popover: "hsl(0 0% 100%)",
      popoverForeground: "hsl(210 40% 15%)",
      // Controls (Barra de Filtros)
      controlsBg: "hsl(0 0% 100%)", // #F0F8FF - Fondo azul muy claro
      controlsForeground: "hsl(210 40% 15%)", // Texto azul oscuro
      controlsBorder: "hsl(210 40% 85%)", // Borde azul suave

      attendanceLateBg: "hsl(258 60% 50%)",
      attendanceLateFg: "hsl(0 0% 100%)",
      attendanceAbsentBg: "hsl(0 84.2% 60.2%)",
      attendanceAbsentFg: "hsl(0 0% 100%)",
      attendancePresentBg: "hsl(210 100% 40%)",
      attendancePresentFg: "hsl(0 0% 100%)",
      attendanceJustifiedBg: "hsl(280 55% 58%)",
      attendanceJustifiedFg: "hsl(0 0% 100%)",
    },
  },
  {
    id: "academic-navy",
    name: "Academic Navy",
    description: "Traditional navy theme perfect for educational institutions",
    family: "conservative",
    colors: {
      primary: "hsl(220 100% 25%)",
      secondary: "hsl(220 40% 95%)",
      accent: "hsl(220 40% 90%)",
      background: "hsl(0 0% 100%)",
      foreground: "hsl(220 40% 15%)",
      muted: "hsl(220 40% 95%)",
      mutedForeground: "hsl(220 20% 50%)",
      card: "hsl(0 0% 100%)",
      cardForeground: "hsl(220 40% 15%)",
      border: "hsl(220 40% 90%)",
      navbar: "hsl(0 0% 100%)",
      toolbar: "hsl(220 40% 98%)",
      header: "hsl(220 100% 25%)",
      paper: "hsl(0 0% 100%)",
      footer: "hsl(220 40% 95%)",
      destructive: "hsl(0 84.2% 60.2%)",
      destructiveForeground: "hsl(210 40% 98%)",
      ring: "hsl(220 100% 25%)",
      input: "hsl(220 40% 90%)",
      popover: "hsl(0 0% 100%)",
      popoverForeground: "hsl(220 40% 15%)",
      // Controls (Barra de Filtros)
      controlsBg: "hsl(0 0% 100%)", // #F0F4FF - Fondo navy muy claro
      controlsForeground: "hsl(220 40% 15%)", // Texto navy oscuro
      controlsBorder: "hsl(220 40% 85%)", // Borde navy suave

      attendanceLateBg: "hsl(258 60% 50%)",
      attendanceLateFg: "hsl(0 0% 100%)",
      attendanceAbsentBg: "hsl(0 84.2% 60.2%)",
      attendanceAbsentFg: "hsl(0 0% 100%)",
      attendancePresentBg: "hsl(220 100% 25%)",
      attendancePresentFg: "hsl(0 0% 100%)",
      attendanceJustifiedBg: "hsl(280 55% 58%)",
      attendanceJustifiedFg: "hsl(0 0% 100%)",
    },
  },
  {
    id: "neutral-stone",
    name: "Neutral Stone",
    description: "Warm neutral theme with stone-inspired tones",
    family: "conservative",
    colors: {
      primary: "hsl(25 10% 35%)",
      secondary: "hsl(25 10% 92%)",
      accent: "hsl(25 10% 88%)",
      background: "hsl(0 0% 100%)",
      foreground: "hsl(25 10% 20%)",
      muted: "hsl(25 10% 92%)",
      mutedForeground: "hsl(25 10% 50%)",
      card: "hsl(0 0% 100%)",
      cardForeground: "hsl(25 10% 20%)",
      border: "hsl(25 10% 88%)",
      navbar: "hsl(0 0% 100%)",
      toolbar: "hsl(25 10% 96%)",
      header: "hsl(25 10% 35%)",
      paper: "hsl(0 0% 100%)",
      footer: "hsl(25 10% 92%)",
      destructive: "hsl(0 84.2% 60.2%)",
      destructiveForeground: "hsl(210 40% 98%)",
      ring: "hsl(25 10% 35%)",
      input: "hsl(25 10% 88%)",
      popover: "hsl(0 0% 100%)",
      popoverForeground: "hsl(25 10% 20%)",
      // Controls (Barra de Filtros)
      controlsBg: "hsl(0 0% 100%)", // #FEFEFE - Fondo stone muy claro
      controlsForeground: "hsl(25 10% 20%)", // Texto stone oscuro
      controlsBorder: "hsl(25 10% 83%)", // Borde stone suave

      attendanceLateBg: "hsl(258 60% 50%)",
      attendanceLateFg: "hsl(0 0% 100%)",
      attendanceAbsentBg: "hsl(0 84.2% 60.2%)",
      attendanceAbsentFg: "hsl(0 0% 100%)",
      attendancePresentBg: "hsl(25 10% 35%)",
      attendancePresentFg: "hsl(0 0% 100%)",
      attendanceJustifiedBg: "hsl(280 55% 58%)",
      attendanceJustifiedFg: "hsl(0 0% 100%)",
    },
  },
  {
    id: "microsoft-teams",
    name: "Microsoft Teams",
    description: "Professional theme inspired by Microsoft Teams",
    family: "conservative",
    colors: {
      // Paleta Base - Semánticos (basados en el azul púrpura característico de Teams #6264A7)
      primary: "hsl(210 80% 45%)", // #6264A7 - Azul púrpura distintivo de Teams
      secondary: "hsl(260 70% 50%)", // Gris azulado muy claro
      accent: "hsl(252 30% 90%)", // Gris azulado claro
      success: "hsl(142 76% 36%)", // Verde estándar
      error: "hsl(0 84.2% 60.2%)", // Rojo estándar
      warning: "hsl(38 92% 50%)", // Amarillo estándar

      // Paleta Base - Neutros (grises suaves de Teams - Fluent Design System)
      "neutral-100": "hsl(0 0% 98%)", // #FAF9F8 - Fondo muy claro
      "neutral-200": "hsl(0 0% 96%)", // #F3F2F1 - Fondo claro
      "neutral-300": "hsl(0 0% 91%)", // #EDEBE9 - Gris medio claro
      "neutral-400": "hsl(0 0% 75%)", // #A19F9D - Gris medio
      "neutral-500": "hsl(0 0% 55%)", // #605E5C - Gris medio oscuro
      "neutral-600": "hsl(0 0% 20%)", // #323130 - Gris oscuro (texto principal)

      // Body y Layout
      background: "hsl(210 30% 92%)", // #FAF9F8 - Fondo principal de Teams
      foreground: "hsl(222.2 84% 4.9%)", // #323130 - Texto principal
      muted: "hsl(0 0% 96%)", // #F3F2F1 - Fondo muted
      mutedForeground: "hsl(0 0% 50%)", // #605E5C - Texto muted

      // Superficies
      card: "hsl(210 30% 96%)", // Blanco puro para cards
      cardForeground: "hsl(222.2 84% 4.9%)", // #323130 - Texto en cards
      paper: "hsl(0 0% 100%)", // Blanco para paper
      surfaceHover: "hsl(252 20% 97%)", // Hover suave azulado
      surfaceSelected: "hsl(252 45% 55%)", // Primary para seleccionado
      surfaceElevated: "hsl(0 0% 100%)", // Blanco para elementos elevados

      // Cards - Estados (siguiendo el estilo de Teams)
      cardHoverBg: "hsl(252 20% 97%)", // Hover suave con tinte azulado
      cardHoverBorder: "hsl(252 30% 85%)", // Borde hover más visible
      cardActiveBg: "hsl(252 45% 95%)", // Active con tinte del primary
      cardActiveBorder: "hsl(252 45% 55%)", // Borde active con primary
      cardSelectedBg: "hsl(252 45% 55%)", // Primary para seleccionado
      cardSelectedForeground: "hsl(0 0% 100%)", // Texto blanco en seleccionado
      cardSelectedBorder: "hsl(252 45% 55%)", // Borde primary
      cardBorder: "hsl(0 0% 91%)", // #EDEBE9 - Borde base suave
      cardBorderRadius: "4px", // Bordes ligeramente redondeados como Teams

      // Bordes
      border: "hsl(210 20% 85%)", // #EDEBE9 - Borde base
      borderHover: "hsl(252 30% 85%)", // Borde hover más visible
      borderFocus: "hsl(252 45% 55%)", // Primary para focus
      borderError: "hsl(0 84.2% 60.2%)", // Rojo para errores

      // Buttons (estilo Fluent UI de Teams)
      buttonPrimaryBg: "hsl(252 45% 55%)", // Primary de Teams
      buttonPrimaryForeground: "hsl(0 0% 100%)", // Blanco
      buttonPrimaryHoverBg: "hsl(252 45% 50%)", // Hover más oscuro
      buttonPrimaryActiveBg: "hsl(252 45% 45%)", // Active más oscuro
      buttonSecondaryBg: "transparent", // Transparente para botones secundarios
      buttonSecondaryForeground: "hsl(252 45% 55%)", // Primary para texto
      buttonSecondaryBorder: "hsl(252 45% 55%)", // Primary para borde

      // Inputs y Formularios (estilo Fluent UI)
      input: "hsl(0 0% 100%)", // Blanco para inputs
      inputPlaceholder: "hsl(0 0% 50%)", // #605E5C - Placeholder
      inputHoverBorder: "hsl(252 30% 85%)", // Borde hover
      inputFocusBorder: "hsl(252 45% 55%)", // Primary para focus
      inputErrorBg: "hsl(0 84.2% 98%)", // Fondo error suave
      inputErrorBorder: "hsl(0 84.2% 60.2%)", // Borde error
      inputSuccessBg: "hsl(142 76% 98%)", // Fondo success suave
      inputSuccessBorder: "hsl(142 76% 36%)", // Borde success

      // Navbar y Header (estilo Teams)
      navbar: "hsl(210 30% 96%)", // Blanco para navbar
      toolbar: "hsl(210 30% 96%)", // #FAF9F8 - Toolbar con fondo suave
      header: "hsl(252 45% 55%)", // Primary para header
      navbarItemHoverBg: "hsl(252 20% 97%)", // Hover suave
      navbarItemSelectedBg: "hsl(252 45% 55%)", // Primary para seleccionado

      // Footer
      footer: "hsl(0 0% 96%)", // #F3F2F1 - Footer gris claro
      footerSeparator: "hsl(0 0% 91%)", // #EDEBE9 - Separador

      // Tablas (estilo Fluent UI de Teams)
      tableBg: "transparent", // Fondo transparente
      tableForeground: "hsl(222.2 84% 4.9%)", // #323130 - Texto principal
      tableBorder: "hsl(0 0% 91%)", // #EDEBE9 - Borde suave
      tableHeaderBg: "hsl(0 0% 98%)", // #FAF9F8 - Fondo header suave
      tableHeaderForeground: "hsl(222.2 84% 4.9%)", // #323130 - Texto header
      tableRowBg: "transparent", // Fondo transparente
      tableRowForeground: "hsl(222.2 84% 4.9%)", // #323130 - Texto fila
      tableRowAlternateBg: "hsl(0 0% 98%)", // #FAF9F8 - Fondo fila alterna suave
      tableRowHoverBg: "hsl(252 20% 97%)", // Hover con tinte azulado suave
      tableRowSelectedBg: "hsl(252 30% 92%)", // Seleccionado con tinte primary más visible (similar al verde claro original)
      tableCellBorder: "hsl(0 0% 91%)", // #EDEBE9 - Borde celda suave

      // Otros Componentes
      destructive: "hsl(0 84.2% 60.2%)", // Rojo para acciones destructivas
      destructiveForeground: "hsl(0 0% 100%)", // Blanco para texto destructivo
      ring: "hsl(252 45% 55%)", // Primary para ring de focus
      popover: "hsl(0 0% 100%)", // Blanco para popovers
      popoverForeground: "hsl(0 0% 20%)", // #323130 - Texto en popovers

      controlsBg: "hsl(210 30% 96%)",
      textTertiary: "rgba(90,90,90,0.55)",
      cardTextColor: "rgba(90,90,90,0.72)",
      textSecondary: "rgba(90,90,90,0.72)",
      cardTitleColor: "hsl(222.2 84% 4.9%)",
      controlsBorder: "hsl(210 20% 80%)",
      inputForeground: "hsl(222.2 84% 4.9%)",
      navbarIconColor: "hsl(222.2 84% 4.9%)",
      attendanceLateBg: "hsl(258 60% 50%)",
    },
    typography: {
      fontFamily: "Sans-Serif", // Segoe UI es la fuente de Teams, pero usamos Sans-Serif como fallback
      fontSizeBase: 14, // Tamaño base estándar de Teams
      lineHeightBase: "normal", // 1.5 - Espaciado normal
      letterSpacingBase: "normal", // 0 - Espaciado normal
      h1: { fontSize: "2.5rem", lineHeight: "1.2" },
      h2: { fontSize: "2rem", lineHeight: "1.2" },
      h3: { fontSize: "1.75rem", lineHeight: "1.3" },
      subtitle1: { fontSize: "1.25rem", lineHeight: "1.4" },
      subtitle2: { fontSize: "1.1rem", lineHeight: "1.4" },
      body1: { fontSize: "1rem", lineHeight: "1.5" },
      body2: { fontSize: "0.875rem", lineHeight: "1.6" },
      caption: { fontSize: "0.75rem", lineHeight: "1.6" },
      overline: { fontSize: "0.625rem", lineHeight: "1.6", textTransform: "uppercase" },
    },
    accessibility: {
      highContrastMode: false, // No es modo alto contraste, pero cumple WCAG AA
    },
  },

  // PLAYFUL / ENGAGING THEMES
  {
    id: "lime-burst",
    name: "Lime Burst",
    description: "Energetic lime green theme perfect for creative learning environments",
    family: "playful",
    baseColor: "#DAEF68",
    colors: {
      primary: "hsl(73 85% 67%)",
      secondary: "hsl(73 30% 85%)",
      accent: "hsl(73 40% 80%)",
      background: "hsl(73 85% 67%)",
      foreground: "hsl(73 30% 15%)",
      muted: "hsl(73 20% 90%)",
      mutedForeground: "hsl(73 15% 40%)",
      card: "hsl(73 85% 67%)",
      cardForeground: "hsl(73 30% 15%)",
      border: "#000000",
      navbar: "hsl(73 85% 67%)",
      toolbar: "hsl(73 40% 95%)",
      header: "hsl(0 0% 100%)",
      paper: "hsl(73 85% 67%)",
      footer: "hsl(73 30% 85%)",
      destructive: "hsl(0 84.2% 60.2%)",
      destructiveForeground: "hsl(210 40% 98%)",
      ring: "hsl(73 85% 67%)",
      input: "hsl(73 30% 85%)",
      popover: "hsl(73 85% 67%)",
      popoverForeground: "hsl(73 30% 15%)",
      // Controls (Barra de Filtros)
      controlsBg: "hsl(73 85% 67%)", // Fondo lime muy claro
      controlsForeground: "hsl(73 30% 15%)", // Texto oscuro
      controlsBorder: "#000000", // Borde lime suave

      cardBorder: "#000000",
      borderFocus: "#000000",
      borderHover: "#000000",
      inputBorder: "1px solid #000000",
      tableBorder: "#000000",
      navbarBorder: "#000000",
      sidebarBorder: "#000000",
      wbCanvasBorder: "#000000",
      cardHoverBorder: "#000000",
      tableCellBorder: "#000000",
      wbToolSetBorder: "#000000",
      attendanceLateBg: "hsl(258 60% 50%)",
      attendanceLateFg: "hsl(0 0% 100%)",
      // Sidebar: overlay oscuro visible sobre cualquier fondo playful
      sidebarItemSelectedBg: "rgba(0, 0, 0, 0.22)",
      sidebarItemHoverBg: "rgba(0, 0, 0, 0.12)",
      sidebarItemSelectedForeground: "#000000",
      navbarItemSelectedBg: "rgba(0, 0, 0, 0.22)",
    },
  },
  {
    id: "lavender-dream",
    name: "Lavender Dream",
    description: "Soft purple theme that sparks creativity and imagination",
    family: "playful",
    baseColor: "#C0BAF2",
    colors: {
      primary: "hsl(248 70% 85%)",
      secondary: "hsl(248 30% 90%)",
      accent: "hsl(248 40% 85%)",
      background: "hsl(248 70% 85%)",
      foreground: "hsl(248 30% 20%)",
      muted: "hsl(248 20% 95%)",
      mutedForeground: "hsl(248 15% 45%)",
      card: "hsl(248 70% 85%)",
      cardForeground: "hsl(248 30% 20%)",
      border: "#000000",
      navbar: "hsl(248 70% 85%)",
      toolbar: "hsl(248 40% 97%)",
      header: "hsl(248 30% 20%)",
      paper: "hsl(248 70% 85%)",
      footer: "hsl(248 30% 90%)",
      destructive: "hsl(0 84.2% 60.2%)",
      destructiveForeground: "hsl(210 40% 98%)",
      ring: "hsl(248 70% 85%)",
      input: "hsl(248 30% 90%)",
      popover: "hsl(248 70% 85%)",
      popoverForeground: "hsl(248 30% 20%)",
      // Controls (Barra de Filtros)
      controlsBg: "hsl(248 70% 85%)", // Fondo lavender muy claro
      controlsForeground: "hsl(248 30% 20%)", // Texto oscuro
      controlsBorder: "#000000", // Borde lavender suave

      cardBorder: "#000000",
      borderFocus: "#000000",
      borderHover: "#000000",
      inputBorder: "1px solid #000000",
      tableBorder: "#000000",
      navbarBorder: "#000000",
      sidebarBorder: "#000000",
      wbCanvasBorder: "#000000",
      cardHoverBorder: "#000000",
      tableCellBorder: "#000000",
      wbToolSetBorder: "#000000",
      attendanceLateBg: "hsl(258 60% 50%)",
      attendanceLateFg: "hsl(0 0% 100%)",
      sidebarItemSelectedBg: "rgba(0, 0, 0, 0.22)",
      sidebarItemHoverBg: "rgba(0, 0, 0, 0.12)",
      sidebarItemSelectedForeground: "#000000",
      navbarItemSelectedBg: "rgba(0, 0, 0, 0.22)",
    },
  },
  {
    id: "mint-fresh",
    name: "Mint Fresh",
    description: "Refreshing mint green theme that energizes learning",
    family: "playful",
    baseColor: "#73D29E",
    colors: {
      primary: "hsl(152 55% 64%)",
      secondary: "hsl(152 30% 85%)",
      accent: "hsl(152 40% 80%)",
      background: "hsl(152 55% 64%)",
      foreground: "hsl(152 30% 20%)",
      muted: "hsl(152 20% 90%)",
      mutedForeground: "hsl(152 15% 40%)",
      card: "hsl(152 55% 64%)",
      cardForeground: "hsl(152 30% 20%)",
      border: "#000000",
      navbar: "hsl(152 55% 64%)",
      toolbar: "hsl(152 40% 95%)",
      header: "hsl(152 55% 64%)",
      paper: "hsl(152 55% 64%)",
      footer: "hsl(152 30% 85%)",
      destructive: "hsl(0 84.2% 60.2%)",
      destructiveForeground: "hsl(210 40% 98%)",
      ring: "hsl(152 55% 64%)",
      input: "hsl(152 30% 85%)",
      popover: "hsl(152 55% 64%)",
      popoverForeground: "hsl(152 30% 20%)",
      // Controls (Barra de Filtros)
      controlsBg: "hsl(152 55% 64%)", // Fondo mint muy claro
      controlsForeground: "hsl(152 30% 20%)", // Texto oscuro
      controlsBorder: "#000000", // Borde mint suave

      cardBorder: "#000000",
      borderFocus: "#000000",
      borderHover: "#000000",
      inputBorder: "1px solid #000000",
      tableBorder: "#000000",
      navbarBorder: "#000000",
      wbCanvasBorder: "#000000",
      sidebarBorder: "#000000",
      cardHoverBorder: "#000000",
      tableCellBorder: "#000000",
      wbToolSetBorder: "#000000",
      attendanceLateBg: "hsl(258 60% 50%)",
      sidebarItemSelectedBg: "rgba(0, 0, 0, 0.22)",
      sidebarItemHoverBg: "rgba(0, 0, 0, 0.12)",
      sidebarItemSelectedForeground: "#000000",
      navbarItemSelectedBg: "rgba(0, 0, 0, 0.22)",
    },
  },
  {
    id: "warm-sand",
    name: "Warm Sand",
    description: "Cozy beige theme that creates a welcoming learning atmosphere",
    family: "playful",
    baseColor: "#BAA694",
    colors: {
      primary: "hsl(32 20% 66%)",
      secondary: "hsl(32 15% 85%)",
      accent: "hsl(32 20% 80%)",
      background: "hsl(32 20% 66%)",
      foreground: "#1a1a1a",
      muted: "hsl(32 10% 90%)",
      mutedForeground: "hsl(32 10% 45%)",
      card: "hsl(32 20% 66%)",
      cardForeground: "#1a1a1a",
      border: "#000000",
      navbar: "hsl(32 20% 66%)",
      toolbar: "hsl(32 15% 95%)",
      header: "hsl(32 20% 66%)",
      paper: "hsl(32 20% 66%)",
      footer: "hsl(32 15% 85%)",
      destructive: "hsl(0 84.2% 60.2%)",
      destructiveForeground: "hsl(210 40% 98%)",
      ring: "hsl(32 20% 66%)",
      input: "hsl(32 15% 85%)",
      popover: "hsl(32 20% 66%)",
      popoverForeground: "hsl(32 20% 15%)",
      // Controls (Barra de Filtros)
      controlsBg: "hsl(32 20% 66%)", // Fondo sand muy claro
      controlsForeground: "#1a1a1a", // Texto oscuro
      controlsBorder: "#000000", // Borde sand suave

      cardBorder: "#000000",
      borderFocus: "#000000",
      borderHover: "#000000",
      inputBorder: "1px solid #000000",
      tableBorder: "#000000",
      navbarBorder: "#000000",
      sidebarBorder: "#000000",
      wbCanvasBorder: "#000000",
      cardHoverBorder: "#000000",
      tableCellBorder: "#000000",
      wbToolSetBorder: "#000000",
      attendanceLateBg: "hsl(258 60% 50%)",
      attendanceLateFg: "hsl(0 0% 100%)",
      sidebarItemSelectedBg: "rgba(0, 0, 0, 0.22)",
      sidebarItemHoverBg: "rgba(0, 0, 0, 0.12)",
      sidebarItemSelectedForeground: "#000000",
      navbarItemSelectedBg: "rgba(0, 0, 0, 0.22)",
      textTertiary: "#1a1a1a",
      cardTextColor: "#1a1a1a",
      textSecondary: "#1a1a1a",
      cardTitleColor: "#1a1a1a",
      inputForeground: "#1a1a1a",
      navbarIconColor: "hsl(32 20% 15%)",
    tableForeground: "hsl(32 20% 15%)",
      cardActiveBorder: "#000000",
      inputFocusBorder: "2px solid #000000",
      inputHoverBorder: "1px solid #000000",
      navbarForeground: "hsl(32 20% 15%)",
      controlsTextColor: "hsl(32 20% 15%)",
    },
  },
  {
    id: "sky-blue",
    name: "Sky Blue",
    description: "Bright sky blue theme that inspires boundless possibilities",
    family: "playful",
    baseColor: "#81C2EC",
    colors: {
      primary: "hsl(202 70% 72%)",
      secondary: "hsl(202 30% 85%)",
      accent: "hsl(202 40% 80%)",
      background: "hsl(202 70% 72%)",
      foreground: "hsl(202 30% 20%)",
      muted: "hsl(202 20% 90%)",
      mutedForeground: "hsl(202 15% 40%)",
      card: "hsl(202 70% 72%)",
      cardForeground: "hsl(202 30% 20%)",
      border: "#000000",
      navbar: "hsl(202 70% 72%)",
      toolbar: "hsl(202 40% 95%)",
      header: "hsl(202 70% 72%)",
      paper: "hsl(202 70% 72%)",
      footer: "hsl(202 30% 85%)",
      destructive: "hsl(0 84.2% 60.2%)",
      destructiveForeground: "hsl(210 40% 98%)",
      ring: "hsl(202 70% 72%)",
      input: "hsl(202 30% 85%)",
      popover: "hsl(202 70% 72%)",
      popoverForeground: "hsl(202 30% 20%)",
      // Controls (Barra de Filtros)
      controlsBg: "hsl(202 70% 72%)", // Fondo sky blue muy claro
      controlsForeground: "hsl(202 30% 20%)", // Texto oscuro
      controlsBorder: "#000000", // Borde sky blue suave

      cardBorder: "#000000",
      borderFocus: "#000000",
      borderHover: "#000000",
      inputBorder: "1px solid #000000",
      tableBorder: "#000000",
      navbarBorder: "#000000",
      sidebarBorder: "#000000",
      wbCanvasBorder: "#000000",
      cardHoverBorder: "#000000",
      tableCellBorder: "#000000",
      wbToolSetBorder: "#000000",
      attendanceLateBg: "hsl(258 60% 50%)",
      sidebarItemSelectedBg: "rgba(0, 0, 0, 0.22)",
      sidebarItemHoverBg: "rgba(0, 0, 0, 0.12)",
      sidebarItemSelectedForeground: "#000000",
      navbarItemSelectedBg: "rgba(0, 0, 0, 0.22)",
    },
  },
  {
    id: "bubblegum-pink",
    name: "Bubblegum Pink",
    description: "Fun pink theme that brings joy and excitement to learning",
    family: "playful",
    baseColor: "#FA9CC6",
    colors: {
      primary: "hsl(330 90% 80%)",
      secondary: "hsl(330 30% 90%)",
      accent: "hsl(330 40% 85%)",
      background: "hsl(330 90% 80%)",
      foreground: "hsl(330 30% 25%)",
      muted: "hsl(330 20% 95%)",
      mutedForeground: "hsl(330 15% 45%)",
      card: "hsl(330 90% 80%)",
      cardForeground: "hsl(330 30% 25%)",
      border: "#000000",
      navbar: "hsl(330 90% 80%)",
      toolbar: "hsl(330 40% 97%)",
      header: "hsl(330 90% 80%)",
      paper: "hsl(330 90% 80%)",
      footer: "hsl(330 30% 90%)",
      destructive: "hsl(0 100% 40%)",
      destructiveForeground: "hsl(210 40% 98%)",
      ring: "hsl(330 90% 80%)",
      input: "hsl(330 30% 90%)",
      popover: "hsl(330 90% 80%)",
      popoverForeground: "hsl(330 30% 25%)",
      // Controls (Barra de Filtros)
      controlsBg: "hsl(330 90% 80%)", // Fondo bubblegum muy claro
      controlsForeground: "hsl(330 30% 25%)", // Texto oscuro
      controlsBorder: "#000000", // Borde bubblegum suave

      cardBorder: "#000000",
      borderFocus: "#000000",
      borderHover: "#000000",
      inputBorder: "1px solid #000000",
      tableBorder: "#000000",
      navbarBorder: "#000000",
      textTertiary: "#1a1a1a",
      cardTextColor: "#1a1a1a",
      sidebarBorder: "#000000",
      textSecondary: "#1a1a1a",
      cardTitleColor: "hsl(330 30% 25%)",
      wbCanvasBorder: "#000000",
      sidebarItemSelectedBg: "rgba(0, 0, 0, 0.22)",
      sidebarItemHoverBg: "rgba(0, 0, 0, 0.12)",
      sidebarItemSelectedForeground: "#000000",
      navbarItemSelectedBg: "rgba(0, 0, 0, 0.22)",
      cardHoverBorder: "#000000",
      inputForeground: "hsl(330 30% 25%)",
      navbarIconColor: "hsl(330 30% 25%)",
      tableCellBorder: "#000000",
      tableForeground: "hsl(330 30% 25%)",
      wbToolSetBorder: "#000000",
    attendanceLateBg: "hsl(258 60% 50%)",
      attendanceLateFg: "hsl(0 0% 100%)",
      cardActiveBorder: "#000000",
      inputFocusBorder: "2px solid #000000",
      inputHoverBorder: "1px solid #000000",
      navbarForeground: "hsl(330 30% 25%)",
    },
  },
  {
    id: "sunshine-yellow",
    name: "Sunshine Yellow",
    description: "Bright yellow theme that radiates positivity and energy",
    family: "playful",
    baseColor: "#FFCE00",
    colors: {
      primary: "hsl(50 100% 50%)",
      secondary: "hsl(50 30% 85%)",
      accent: "hsl(50 40% 80%)",
      background: "hsl(50 100% 50%)",
      foreground: "hsl(50 30% 20%)",
      muted: "hsl(50 20% 90%)",
      mutedForeground: "hsl(50 15% 40%)",
      // Monocromático: card = background (fondo de cards igual al fondo de página)
      card: "hsl(50 100% 50%)",
      cardForeground: "hsl(50 30% 20%)",
      // Bordes oscuros (monocromático = alto contraste sobre fondo saturado)
      border: "#000000",
      cardBorder: "#000000",
      navbar: "hsl(50 100% 50%)",
      toolbar: "hsl(50 40% 95%)",
      header: "hsl(50 100% 50%)",
      paper: "hsl(50 100% 50%)",
      footer: "hsl(50 30% 85%)",
      destructive: "hsl(0 84.2% 60.2%)",
      destructiveForeground: "hsl(210 40% 98%)",
      ring: "hsl(50 100% 50%)",
      input: "hsl(50 30% 85%)",
      popover: "hsl(50 100% 50%)",
      popoverForeground: "hsl(50 30% 20%)",
      // Controls (Barra de Filtros) — navbar como base (monochromatic)
      controlsBg: "hsl(50 100% 50%)",
      controlsForeground: "hsl(50 30% 20%)",
      controlsBorder: "#000000",

      borderFocus: "#000000",
      borderHover: "#000000",
      inputBorder: "1px solid #000000",
      tableBorder: "#000000",
      navbarBorder: "#000000",
      sidebarBorder: "#000000",
      wbCanvasBorder: "#000000",
      cardHoverBorder: "#000000",
      // Tokens de estado de asistencia: colores semánticos visibles independientemente
      // del fondo del tema (el background amarillo no sirve para indicar "Presente").
      attendancePresentBg: "hsl(50 100% 50%)",   // verde semántico
      attendancePresentFg: "hsl(0 0% 100%)",
      attendanceAbsentBg: "hsl(0 84.2% 60.2%)",  // rojo semántico
      attendanceAbsentFg: "hsl(0 0% 100%)",
      attendanceLateBg: "hsl(258 60% 50%)",       // púrpura semántico
      attendanceLateFg: "hsl(0 0% 100%)",
      attendanceJustifiedBg: "hsl(280 55% 58%)",  // púrpura oscuro
      attendanceJustifiedFg: "hsl(0 0% 100%)",
      attendanceHomeIconDefault: "#b1b4b1",
      attendanceHomeIconVirtual: "hsl(50 100% 50%)",
      attendanceCheckboxCheckedBg: "hsl(258 60% 50%)",
      tableCellBorder: "#000000",
      wbToolSetBorder: "#000000",
      cardActiveBorder: "#000000",
      inputFocusBorder: "2px solid #000000",
      inputHoverBorder: "1px solid #000000",
      cardSelectedBorder: "#000000",
      sidebarItemSelectedBg: "rgba(0, 0, 0, 0.22)",
      sidebarItemHoverBg: "rgba(0, 0, 0, 0.12)",
      sidebarItemSelectedForeground: "#000000",
      navbarItemSelectedBg: "rgba(0, 0, 0, 0.22)",
    },
  },
  {
    id: "periwinkle-blue",
    name: "Periwinkle Blue",
    description: "Soft periwinkle blue theme that promotes calm focus",
    family: "playful",
    baseColor: "#8F9BFF",
    colors: {
      primary: "hsl(232 100% 78%)",
      secondary: "hsl(232 30% 85%)",
      accent: "hsl(232 40% 80%)",
      background: "hsl(232 100% 78%)",
      foreground: "hsl(232 30% 15%)",
      muted: "hsl(232 20% 90%)",
      mutedForeground: "hsl(232 15% 40%)",
      card: "hsl(232 100% 78%)",
      cardForeground: "hsl(232 30% 15%)",
      border: "#000000",
      navbar: "hsl(232 100% 78%)",
      toolbar: "hsl(232 40% 95%)",
      header: "hsl(232 100% 78%)",
      paper: "hsl(232 100% 78%)",
      footer: "hsl(232 30% 85%)",
      destructive: "hsl(0 100% 40%)",
      destructiveForeground: "hsl(0 0% 100%)",
      ring: "hsl(232 100% 78%)",
      input: "hsl(232 30% 85%)",
      popover: "hsl(232 100% 78%)",
      popoverForeground: "hsl(232 30% 15%)",
      // Controls (Barra de Filtros)
      controlsBg: "hsl(232 100% 78%)", // Fondo periwinkle muy claro
      controlsForeground: "hsl(232 30% 15%)", // Texto oscuro
      controlsBorder: "#000000", // Borde periwinkle suave

      cardBorder: "#000000",
      borderFocus: "#000000",
      borderHover: "#000000",
      inputBorder: "1px solid #000000",
      tableBorder: "#000000",
      navbarBorder: "#000000",
      sidebarBorder: "#000000",
      wbCanvasBorder: "#000000",
      cardHoverBorder: "#000000",
      tableCellBorder: "#000000",
      wbToolSetBorder: "#000000",
      attendanceLateBg: "hsl(258 60% 50%)",
      attendanceLateFg: "hsl(0 0% 100%)",
      sidebarItemSelectedBg: "rgba(0, 0, 0, 0.22)",
      sidebarItemHoverBg: "rgba(0, 0, 0, 0.12)",
      sidebarItemSelectedForeground: "#000000",
      navbarItemSelectedBg: "rgba(0, 0, 0, 0.22)",
      textTertiary: "#1a1a1a",
      cardTextColor: "#1a1a1a",
      textSecondary: "#1a1a1a",
      cardTitleColor: "hsl(232 30% 15%)",
      inputForeground: "hsl(232 30% 15%)",
      navbarIconColor: "hsl(232 30% 15%)",
      tableForeground: "hsl(232 30% 15%)",
      cardActiveBorder: "#000000",
      inputFocusBorder: "2px solid #000000",
      inputHoverBorder: "1px solid #000000",
      navbarForeground: "hsl(232 30% 15%)",
    },
  },
  // ACCESSIBILITY FOCUSED THEMES
  {
    id: "high-contrast-light",
    name: "Alto Contraste Claro",
    description: "Tema de alto contraste optimizado para accesibilidad visual máxima (WCAG AAA)",
    family: "accessibility",
    colors: {
      // Paleta Base - Máximo contraste
      primary: "hsl(0 0% 0%)",
      secondary: "hsl(0 0% 20%)",
      accent: "hsl(0 0% 10%)",
      success: "hsl(120 100% 25%)",
      error: "hsl(0 100% 50%)",
      warning: "hsl(45 100% 50%)",

      // Neutros - Alto contraste
      "neutral-100": "hsl(0 0% 100%)",
      "neutral-200": "hsl(0 0% 95%)",
      "neutral-300": "hsl(0 0% 85%)",
      "neutral-400": "hsl(0 0% 50%)",
      "neutral-500": "hsl(0 0% 30%)",
      "neutral-600": "hsl(0 0% 0%)",

      // Body
      background: "hsl(0 0% 100%)",
      foreground: "hsl(0 0% 0%)",
      muted: "hsl(0 0% 95%)",
      mutedForeground: "hsl(0 0% 30%)",

      // Superficies
      card: "hsl(0 0% 100%)",
      cardForeground: "hsl(0 0% 0%)",
      paper: "hsl(0 0% 100%)",
      surfaceHover: "hsl(0 0% 95%)",
      surfaceSelected: "hsl(0 0% 0%)",
      surfaceElevated: "hsl(0 0% 100%)",

      // Cards - Estados con alto contraste
      cardHoverBg: "hsl(0 0% 95%)",
      cardHoverBorder: "hsl(0 0% 0%)",
      cardActiveBg: "hsl(0 0% 90%)",
      cardActiveBorder: "hsl(0 0% 0%)",
      cardSelectedBg: "hsl(0 0% 0%)",
      cardSelectedForeground: "hsl(0 0% 100%)",
      cardSelectedBorder: "hsl(0 0% 0%)",

      // Bordes - Alto contraste
      border: "hsl(0 0% 0%)",
      borderHover: "hsl(0 0% 0%)",
      borderFocus: "hsl(0 0% 0%)",
      borderError: "hsl(0 100% 50%)",

      // Buttons - Alto contraste
      buttonPrimaryBg: "hsl(0 0% 0%)",
      buttonPrimaryForeground: "hsl(0 0% 100%)",
      buttonPrimaryHoverBg: "hsl(0 0% 20%)",
      buttonPrimaryActiveBg: "hsl(0 0% 30%)",
      buttonSecondaryBg: "transparent",
      buttonSecondaryForeground: "hsl(0 0% 0%)",
      buttonSecondaryBorder: "hsl(0 0% 0%)",

      // Inputs - Alto contraste
      input: "hsl(0 0% 100%)",
      inputPlaceholder: "hsl(0 0% 50%)",
      inputHoverBorder: "hsl(0 0% 0%)",
      inputFocusBorder: "hsl(0 0% 0%)",
      inputErrorBg: "hsl(0 100% 95%)",
      inputErrorBorder: "hsl(0 100% 50%)",
      inputSuccessBg: "hsl(120 100% 95%)",
      inputSuccessBorder: "hsl(120 100% 25%)",

      // Navbar
      navbar: "hsl(0 0% 100%)",
      toolbar: "hsl(0 0% 95%)",
      header: "hsl(0 0% 0%)",
      navbarItemHoverBg: "hsl(0 0% 95%)",
      navbarItemSelectedBg: "hsl(0 0% 0%)",

      // Footer
      footer: "hsl(0 0% 95%)",
      footerSeparator: "hsl(0 0% 0%)",

      // Otros
      destructive: "hsl(0 100% 50%)",
      destructiveForeground: "hsl(0 0% 100%)",
      ring: "hsl(0 0% 0%)",
      popover: "hsl(0 0% 100%)",
      popoverForeground: "hsl(0 0% 0%)",

      controlsBg: "hsl(0 0% 100%)",
      controlsBorder: "hsl(0 0% 0%)",
      attendanceLateBg: "hsl(258 60% 50%)",
      attendanceLateFg: "hsl(0 0% 100%)",
      attendanceAbsentBg: "hsl(0 84.2% 60.2%)",
      attendanceAbsentFg: "hsl(0 0% 100%)",
      controlsForeground: "hsl(0 0% 0%)",
      attendancePresentBg: "hsl(0 0% 0%)",
      attendancePresentFg: "hsl(0 0% 100%)",
      attendanceJustifiedBg: "hsl(280 55% 58%)",
    },
    typography: {
      fontFamily: "Sans-Serif",
      fontSizeBase: 18, // Tamaño mayor para mejor legibilidad
      lineHeightBase: "relaxed", // Mayor espacio entre líneas
      letterSpacingBase: "wide", // Mayor espaciado de letras
    },
  },
  {
    id: "high-contrast-dark",
    name: "Alto Contraste Oscuro",
    description: "Tema de alto contraste oscuro optimizado para accesibilidad visual máxima (WCAG AAA)",
    family: "accessibility",
    colors: {
      // Paleta Base - Máximo contraste oscuro
      primary: "hsl(0 0% 100%)",
      secondary: "hsl(0 0% 80%)",
      accent: "hsl(0 0% 90%)",
      success: "hsl(120 100% 75%)",
      error: "hsl(0 100% 70%)",
      warning: "hsl(45 100% 70%)",

      // Neutros - Alto contraste oscuro
      "neutral-100": "hsl(0 0% 10%)",
      "neutral-200": "hsl(0 0% 15%)",
      "neutral-300": "hsl(0 0% 25%)",
      "neutral-400": "hsl(0 0% 50%)",
      "neutral-500": "hsl(0 0% 70%)",
      "neutral-600": "hsl(0 0% 100%)",

      // Body
      background: "hsl(0 0% 0%)",
      foreground: "hsl(0 0% 100%)",
      muted: "hsl(0 0% 10%)",
      mutedForeground: "hsl(0 0% 70%)",

      // Superficies
      card: "hsl(0 0% 0%)",
      cardForeground: "hsl(0 0% 100%)",
      paper: "hsl(0 0% 0%)",
      surfaceHover: "hsl(0 0% 10%)",
      surfaceSelected: "hsl(0 0% 100%)",
      surfaceElevated: "hsl(0 0% 5%)",

      // Cards - Estados con alto contraste
      cardHoverBg: "hsl(0 0% 10%)",
      cardHoverBorder: "hsl(0 0% 100%)",
      cardActiveBg: "hsl(0 0% 15%)",
      cardActiveBorder: "hsl(0 0% 100%)",
      cardSelectedBg: "hsl(0 0% 100%)",
      cardSelectedForeground: "hsl(0 0% 0%)",
      cardSelectedBorder: "hsl(0 0% 100%)",

      // Bordes - Alto contraste
      border: "hsl(0 0% 100%)",
      borderHover: "hsl(0 0% 100%)",
      borderFocus: "hsl(0 0% 100%)",
      borderError: "hsl(0 100% 70%)",

      // Buttons - Alto contraste
      buttonPrimaryBg: "hsl(0 0% 100%)",
      buttonPrimaryForeground: "hsl(0 0% 0%)",
      buttonPrimaryHoverBg: "hsl(0 0% 80%)",
      buttonPrimaryActiveBg: "hsl(0 0% 70%)",
      buttonSecondaryBg: "transparent",
      buttonSecondaryForeground: "hsl(0 0% 100%)",
      buttonSecondaryBorder: "hsl(0 0% 100%)",

      // Inputs - Alto contraste
      input: "hsl(0 0% 5%)",
      inputPlaceholder: "hsl(0 0% 50%)",
      inputHoverBorder: "hsl(0 0% 100%)",
      inputFocusBorder: "hsl(0 0% 100%)",
      inputErrorBg: "hsl(0 100% 10%)",
      inputErrorBorder: "hsl(0 100% 70%)",
      inputSuccessBg: "hsl(120 100% 10%)",
      inputSuccessBorder: "hsl(120 100% 75%)",

      // Navbar
      navbar: "hsl(0 0% 0%)",
      toolbar: "hsl(0 0% 5%)",
      header: "hsl(0 0% 100%)",
      navbarItemHoverBg: "hsl(0 0% 10%)",
      navbarItemSelectedBg: "hsl(0 0% 100%)",

      // Footer
      footer: "hsl(0 0% 10%)",
      footerSeparator: "hsl(0 0% 100%)",

      // Otros
      destructive: "hsl(0 100% 70%)",
      destructiveForeground: "hsl(0 0% 0%)",
      ring: "hsl(0 0% 100%)",
      popover: "hsl(0 0% 0%)",
      popoverForeground: "hsl(0 0% 100%)",

      controlsBg: "hsl(0 0% 0%)",
      controlsBorder: "hsl(0 0% 100%)",
      attendanceLateBg: "hsl(258 60% 50%)",
      attendanceLateFg: "hsl(0 0% 100%)",
      attendanceAbsentBg: "hsl(0 84.2% 60.2%)",
      attendanceAbsentFg: "hsl(0 0% 100%)",
      controlsForeground: "hsl(0 0% 100%)",
      attendancePresentBg: "hsl(0 0% 100%)",
      attendancePresentFg: "hsl(0 0% 100%)",
      attendanceJustifiedBg: "hsl(280 55% 58%)",
      attendanceJustifiedFg: "hsl(0 0% 100%)",
    },
    typography: {
      fontFamily: "Sans-Serif",
      fontSizeBase: 18, // Tamaño mayor para mejor legibilidad
      lineHeightBase: "relaxed", // Mayor espacio entre líneas
      letterSpacingBase: "wide", // Mayor espaciado de letras
    },
  },

  {
    "id": "amber-glow",
    "name": "Amber Glow",
    "description": "Tema oficial: Amber Glow",
    "family": "conservative",
    "baseColor": "#EEB072",
    "colors": {
      "card": "hsl(30 30% 96%)",
      "border": "hsl(30 20% 85%)",
      "navbar": "hsl(30 30% 96%)",
      "primary": "hsl(30 78% 69%)",
      "toolbar": "hsl(30 30% 96%)",
      "secondary": "hsl(30 20% 90%)",
      "background": "hsl(30 30% 92%)",
      "controlsBg": "hsl(30 30% 96%)",
      "foreground": "hsl(30 40% 15%)",
      "textTertiary": "rgba(90,70,60,0.55)",
      "cardTextColor": "rgba(90,70,60,0.72)",
      "textSecondary": "rgba(90,70,60,0.72)",
      "cardForeground": "hsl(30 40% 15%)",
      "cardTitleColor": "hsl(30 40% 15%)",
      "controlsBorder": "hsl(30 20% 80%)",
      "inputForeground": "hsl(30 40% 15%)",
      "navbarIconColor": "hsl(30 40% 15%)",
      "tableForeground": "hsl(30 40% 15%)",
      "attendanceLateBg": "hsl(258 60% 50%)",
      "attendanceLateFg": "hsl(0 0% 100%)",
      "navbarForeground": "hsl(30 40% 15%)",
      "controlsTextColor": "hsl(30 40% 15%)",
      "sidebarForeground": "hsl(30 40% 15%)",
      "attendanceAbsentBg": "hsl(0 84.2% 60.2%)",
      "attendanceAbsentFg": "hsl(0 0% 100%)",
      "controlsForeground": "hsl(30 40% 15%)",
      "tableRowForeground": "hsl(30 40% 15%)",
      "attendancePresentBg": "hsl(30 78% 69%)",
      "attendancePresentFg": "hsl(0 0% 100%)",
      "navbarIconHoverColor": "hsl(30 40% 15%)",
      "navbarItemForeground": "hsl(30 40% 15%)",
      "attendanceJustifiedBg": "hsl(280 55% 58%)",
      "attendanceJustifiedFg": "hsl(0 0% 100%)",
      "inputPlaceholderColor": "rgba(90,70,60,0.6)",
      "sidebarItemForeground": "hsl(30 40% 15%)",
      "tableHeaderForeground": "hsl(30 40% 15%)",
      "rightSidebarForeground": "hsl(30 40% 15%)",
      "sidebarHeaderForeground": "hsl(30 40% 15%)",
      "sidebarToggleForeground": "hsl(30 40% 15%)",
      "attendanceHomeIconDefault": "#b1b4b1",
      "attendanceHomeIconVirtual": "hsl(30 78% 69%)",
      "rightSidebarItemForeground": "hsl(30 40% 15%)",
      "attendanceCheckboxCheckedBg": "hsl(258 60% 50%)",
      "navbarItemSelectedForeground": "hsl(30 40% 15%)",
      "rightSidebarHeaderForeground": "hsl(30 40% 15%)",
      "rightSidebarToggleForeground": "hsl(30 40% 15%)",
      "rightSidebarHistoryTitleColor": "hsl(30 40% 15%)",
      "rightSidebarHistoryPreviewColor": "rgba(90,70,60,0.72)",
      "rightSidebarHistoryTimestampColor": "rgba(90,70,60,0.6)"
    },
    "typography": {
      "fontFamily": "Sans-Serif",
      "fontSizeBase": 16,
      "lineHeightBase": "normal"
    }
  },

  {
    "id": "amber-gold",
    "name": "Amber Gold",
    "description": "Elegante dorado ámbar, sofisticado y cálido para entornos premium",
    "family": "conservative",
    "baseColor": "#d97706",
    "colors": {
      "card": "hsl(45 30% 96%)",
      "border": "hsl(45 20% 85%)",
      "navbar": "hsl(45 30% 96%)",
      "primary": "hsl(45 80% 50%)",
      "toolbar": "hsl(45 30% 96%)",
      "secondary": "hsl(45 20% 90%)",
      "background": "hsl(45 30% 92%)",
      "controlsBg": "hsl(45 30% 96%)",
      "foreground": "hsl(45 40% 15%)",
      "textTertiary": "rgba(95,85,60,0.55)",
      "cardTextColor": "rgba(95,85,60,0.72)",
      "textSecondary": "rgba(95,85,60,0.72)",
      "cardForeground": "hsl(45 40% 15%)",
      "cardTitleColor": "hsl(45 40% 15%)",
      "controlsBorder": "hsl(45 20% 80%)",
      "inputForeground": "hsl(45 40% 15%)",
      "navbarIconColor": "hsl(45 40% 15%)",
      "tableForeground": "hsl(45 40% 15%)",
      "attendanceLateBg": "hsl(258 60% 50%)",
      "attendanceLateFg": "hsl(0 0% 100%)",
      "navbarForeground": "hsl(45 40% 15%)",
      "controlsTextColor": "hsl(45 40% 15%)",
      "sidebarForeground": "hsl(45 40% 15%)",
      "attendanceAbsentBg": "hsl(0 84.2% 60.2%)",
      "attendanceAbsentFg": "hsl(0 0% 100%)",
      "controlsForeground": "hsl(45 40% 15%)",
      "tableRowForeground": "hsl(45 40% 15%)",
      "attendancePresentBg": "hsl(45 80% 50%)",
      "attendancePresentFg": "hsl(0 0% 100%)",
      "navbarIconHoverColor": "hsl(45 40% 15%)",
      "navbarItemForeground": "hsl(45 40% 15%)",
      "attendanceJustifiedBg": "hsl(280 55% 58%)",
      "attendanceJustifiedFg": "hsl(0 0% 100%)",
      "inputPlaceholderColor": "rgba(95,85,60,0.6)",
      "sidebarItemForeground": "hsl(45 40% 15%)",
      "tableHeaderForeground": "hsl(45 40% 15%)",
      "rightSidebarForeground": "hsl(45 40% 15%)",
      "sidebarHeaderForeground": "hsl(45 40% 15%)",
      "sidebarToggleForeground": "hsl(45 40% 15%)",
      "attendanceHomeIconDefault": "#b1b4b1",
      "attendanceHomeIconVirtual": "hsl(45 80% 50%)",
      "rightSidebarItemForeground": "hsl(45 40% 15%)",
      "attendanceCheckboxCheckedBg": "hsl(258 60% 50%)",
      "navbarItemSelectedForeground": "hsl(45 40% 15%)",
      "rightSidebarHeaderForeground": "hsl(45 40% 15%)",
      "rightSidebarToggleForeground": "hsl(45 40% 15%)",
      "rightSidebarHistoryTitleColor": "hsl(45 40% 15%)",
      "rightSidebarHistoryPreviewColor": "rgba(95,85,60,0.72)",
      "rightSidebarHistoryTimestampColor": "rgba(95,85,60,0.6)"
    },
    "typography": {
      "fontFamily": "Sans-Serif",
      "fontSizeBase": 16,
      "lineHeightBase": "normal"
    }
  },

  {
    "id": "back-to-80s",
    "name": "Back To 80s",
    "description": "Tema personalizado: Back To 80s",
    "family": "conservative",
    "baseColor": "#A655F6",
    "colors": {
      "card": "hsl(210 20% 12%)",
      "border": "hsl(270 60% 30%)",
      "navbar": "hsl(210 20% 12%)",
      "primary": "hsl(270 90% 65%)",
      "toolbar": "hsl(210 20% 12%)",
      "secondary": "hsl(270 60% 25%)",
      "sidebarBg": "hsl(210 20% 9%)",
      "background": "hsl(210 15% 8%)",
      "controlsBg": "hsl(210 20% 12%)",
      "foreground": "#ffffff",
      "cardHoverBg": "hsl(210 20% 15%)",
      "cardActiveBg": "hsl(270 28% 18%)",
      "surfaceHover": "hsl(210 20% 15%)",
      "textTertiary": "rgba(255,255,255,0.55)",
      "cardTextColor": "rgba(255,255,255,0.72)",
      "sidebarBorder": "hsl(270 60% 22%)",
      "sidebarItemBg": "transparent",
      "textSecondary": "rgba(255,255,255,0.72)",
      "cardForeground": "#ffffff",
      "cardSelectedBg": "hsl(270 32% 28%)",
      "cardTitleColor": "#ffffff",
      "controlsBorder": "hsl(270 60% 35%)",
      "cardHoverBorder": "hsl(270 60% 30%)",
      "inputForeground": "#ffffff",
      "navbarIconColor": "#ffffff",
      "surfaceSelected": "hsl(270 32% 28%)",
      "tableForeground": "#ffffff",
      "tableRowHoverBg": "hsl(210 20% 15%)",
      "attendanceLateBg": "hsl(258 60% 50%)",
      "attendanceLateFg": "hsl(0 0% 100%)",
      "cardActiveBorder": "hsl(270 38% 38%)",
      "navbarForeground": "#ffffff",
      "buttonSecondaryBg": "transparent",
      "controlsTextColor": "#ffffff",
      "navbarItemHoverBg": "hsl(210 20% 14%)",
      "sidebarForeground": "#ffffff",
      "attendanceAbsentBg": "hsl(0 84.2% 60.2%)",
      "attendanceAbsentFg": "hsl(0 0% 100%)",
      "cardSelectedBorder": "hsl(270 42% 42%)",
      "controlsForeground": "#ffffff",
      "sidebarItemHoverBg": "hsl(210 20% 15%)",
      "tableRowForeground": "#ffffff",
      "tableRowSelectedBg": "hsl(270 32% 28%)",
      "attendancePresentBg": "hsl(270 90% 65%)",
      "attendancePresentFg": "hsl(0 0% 100%)",
      "sidebarItemActiveBg": "hsl(270 28% 18%)",
      "cardActiveForeground": "#ffffff",
      "navbarIconHoverColor": "#ffffff",
      "navbarItemForeground": "#ffffff",
      "attendanceJustifiedBg": "hsl(280 55% 58%)",
      "attendanceJustifiedFg": "hsl(0 0% 100%)",
      "buttonSecondaryBorder": "1px solid #ffffff",
      "inputPlaceholderColor": "rgba(255,255,255,0.6)",
      "sidebarItemForeground": "#ffffff",
      "sidebarItemSelectedBg": "hsl(270 32% 28%)",
      "tableHeaderForeground": "#ffffff",
      "cardSelectedForeground": "hsl(210 40% 98%)",
      "rightSidebarForeground": "#ffffff",
      "sidebarHeaderForeground": "#ffffff",
      "sidebarToggleForeground": "#ffffff",
      "attendanceHomeIconDefault": "#b1b4b1",
      "attendanceHomeIconVirtual": "hsl(270 90% 65%)",
      "attendanceTableRowHoverBg": "hsl(210 20% 15%)",
      "buttonSecondaryForeground": "#ffffff",
      "sidebarItemSelectedBorder": "hsl(270 40% 40%)",
      "surfaceSelectedForeground": "#ffffff",
      "attendanceTableRowActiveBg": "hsl(270 28% 20%)",
      "rightSidebarItemForeground": "#ffffff",
      "sidebarItemHoverForeground": "#ffffff",
      "tableRowSelectedForeground": "hsl(210 40% 98%)",
      "attendanceCheckboxCheckedBg": "hsl(258 60% 50%)",
      "sidebarItemActiveForeground": "#ffffff",
      "attendanceTableRowSelectedBg": "hsl(270 32% 28%)",
      "navbarItemSelectedForeground": "#ffffff",
      "rightSidebarHeaderForeground": "#ffffff",
      "rightSidebarToggleForeground": "#ffffff",
      "attendanceTableRowHoverBorder": "hsl(270 60% 30%)",
      "rightSidebarHistoryTitleColor": "#ffffff",
      "sidebarItemSelectedForeground": "hsl(210 40% 98%)",
      "attendanceTableRowActiveBorder": "hsl(270 90% 65%)",
      "rightSidebarHistoryPreviewColor": "rgba(255,255,255,0.72)",
      "attendanceTableRowSelectedBorder": "hsl(270 90% 50%)",
      "attendanceTableRowHoverForeground": "#ffffff",
      "rightSidebarHistoryTimestampColor": "rgba(255,255,255,0.6)",
      "attendanceTableRowActiveForeground": "#ffffff",
      "attendanceTableRowSelectedForeground": "hsl(210 40% 98%)"
    },
    "typography": {
      "fontFamily": "Sans-Serif",
      "fontSizeBase": 16,
      "lineHeightBase": "normal"
    }
  },

  {
    "id": "burgundy-wine",
    "name": "Burgundy Wine",
    "description": "Profundo vino borgoña, elegante y distinguido para presentaciones ejecutivas",
    "family": "conservative",
    "baseColor": "#7f1d1d",
    "colors": {
      "card": "hsl(350 30% 96%)",
      "border": "hsl(350 20% 85%)",
      "navbar": "hsl(350 30% 96%)",
      "primary": "hsl(350 60% 45%)",
      "toolbar": "hsl(350 30% 96%)",
      "secondary": "hsl(350 20% 90%)",
      "background": "hsl(350 30% 92%)",
      "controlsBg": "hsl(350 30% 96%)",
      "foreground": "hsl(350 40% 15%)",
      "textTertiary": "rgba(90,70,75,0.55)",
      "cardTextColor": "rgba(90,70,75,0.72)",
      "textSecondary": "rgba(90,70,75,0.72)",
      "cardForeground": "hsl(350 40% 15%)",
      "cardTitleColor": "hsl(350 40% 15%)",
      "controlsBorder": "hsl(350 20% 80%)",
      "inputForeground": "hsl(350 40% 15%)",
      "navbarIconColor": "hsl(350 40% 15%)",
      "tableForeground": "hsl(350 40% 15%)",
      "attendanceLateBg": "hsl(258 60% 50%)",
      "attendanceLateFg": "hsl(0 0% 100%)",
      "navbarForeground": "#1a1a1a",
      "controlsTextColor": "hsl(350 40% 15%)",
      "sidebarForeground": "hsl(350 40% 15%)",
      "attendanceAbsentBg": "hsl(0 84.2% 60.2%)",
      "attendanceAbsentFg": "hsl(0 0% 100%)",
      "controlsForeground": "hsl(350 40% 15%)",
      "tableRowForeground": "hsl(350 40% 15%)",
      "attendancePresentBg": "hsl(350 60% 45%)",
      "attendancePresentFg": "hsl(0 0% 100%)",
      "navbarIconHoverColor": "hsl(350 40% 15%)",
      "navbarItemForeground": "#1a1a1a",
      "attendanceJustifiedBg": "hsl(280 55% 58%)",
      "attendanceJustifiedFg": "hsl(0 0% 100%)",
      "inputPlaceholderColor": "rgba(90,70,75,0.6)",
      "sidebarItemForeground": "hsl(350 40% 15%)",
      "tableHeaderForeground": "hsl(350 40% 15%)",
      "rightSidebarForeground": "hsl(350 40% 15%)",
      "sidebarHeaderForeground": "hsl(350 40% 15%)",
      "sidebarToggleForeground": "hsl(350 40% 15%)",
      "attendanceHomeIconDefault": "#b1b4b1",
      "attendanceHomeIconVirtual": "hsl(350 60% 45%)",
      "rightSidebarItemForeground": "hsl(350 40% 15%)",
      "attendanceCheckboxCheckedBg": "hsl(258 60% 50%)",
      "navbarItemSelectedForeground": "hsl(350 40% 15%)",
      "rightSidebarHeaderForeground": "hsl(350 40% 15%)",
      "rightSidebarToggleForeground": "hsl(350 40% 15%)",
      "rightSidebarHistoryTitleColor": "hsl(350 40% 15%)",
      "rightSidebarHistoryPreviewColor": "rgba(90,70,75,0.72)",
      "rightSidebarHistoryTimestampColor": "rgba(90,70,75,0.6)"
    },
    "typography": {
      "fontFamily": "Sans-Serif",
      "fontSizeBase": 16,
      "lineHeightBase": "normal"
    }
  },

  {
    "id": "forest-essence",
    "name": "Forest Essence",
    "description": "Tema verde bosque profesional, perfecto para instituciones educativas y ambientales",
    "family": "conservative",
    "baseColor": "#166534",
    "colors": {
      "card": "hsl(0 0% 100%)",
      "border": "hsl(142 20% 91%)",
      "navbar": "hsl(0 0% 100%)",
      "primary": "hsl(142 76% 36%)",
      "toolbar": "hsl(142 20% 98%)",
      "secondary": "hsl(142 20% 96%)",
      "background": "hsl(0 0% 100%)",
      "controlsBg": "hsl(142 20% 98%)",
      "foreground": "hsl(142 40% 15%)",
      "textTertiary": "rgba(60,60,60,0.55)",
      "cardTextColor": "rgba(60,60,60,0.72)",
      "textSecondary": "rgba(60,60,60,0.72)",
      "cardForeground": "hsl(142 40% 15%)",
      "cardTitleColor": "hsl(142 40% 15%)",
      "controlsBorder": "hsl(142 20% 85%)",
      "inputForeground": "hsl(142 40% 15%)",
      "navbarIconColor": "hsl(142 40% 15%)",
      "tableForeground": "hsl(142 40% 15%)",
      "attendanceLateBg": "hsl(258 60% 50%)",
      "attendanceLateFg": "hsl(0 0% 100%)",
      "navbarForeground": "#1a1a1a",
      "controlsTextColor": "hsl(142 40% 15%)",
      "sidebarForeground": "hsl(142 40% 15%)",
      "attendanceAbsentBg": "hsl(0 84.2% 60.2%)",
      "attendanceAbsentFg": "hsl(0 0% 100%)",
      "controlsForeground": "hsl(142 40% 15%)",
      "tableRowForeground": "hsl(142 40% 15%)",
      "attendancePresentBg": "hsl(142 76% 36%)",
      "attendancePresentFg": "hsl(0 0% 100%)",
      "navbarIconHoverColor": "hsl(142 40% 15%)",
      "navbarItemForeground": "#1a1a1a",
      "attendanceJustifiedBg": "hsl(280 55% 58%)",
      "attendanceJustifiedFg": "hsl(0 0% 100%)",
      "inputPlaceholderColor": "rgba(60,60,60,0.6)",
      "sidebarItemForeground": "hsl(142 40% 15%)",
      "tableHeaderForeground": "hsl(142 40% 15%)",
      "rightSidebarForeground": "hsl(142 40% 15%)",
      "sidebarHeaderForeground": "hsl(142 40% 15%)",
      "sidebarToggleForeground": "hsl(142 40% 15%)",
      "attendanceHomeIconDefault": "#b1b4b1",
      "attendanceHomeIconVirtual": "hsl(142 76% 36%)",
      "rightSidebarItemForeground": "hsl(142 40% 15%)",
      "attendanceCheckboxCheckedBg": "hsl(258 60% 50%)",
      "navbarItemSelectedForeground": "hsl(142 40% 15%)",
      "rightSidebarHeaderForeground": "hsl(142 40% 15%)",
      "rightSidebarToggleForeground": "hsl(142 40% 15%)",
      "rightSidebarHistoryTitleColor": "hsl(142 40% 15%)",
      "rightSidebarHistoryPreviewColor": "rgba(60,60,60,0.72)",
      "rightSidebarHistoryTimestampColor": "rgba(60,60,60,0.6)"
    },
    "typography": {
      "fontFamily": "Sans-Serif",
      "fontSizeBase": 16,
      "lineHeightBase": "normal"
    }
  },

  {
    "id": "ivory-cream",
    "name": "Ivory Cream",
    "description": "Suave marfil crema, cálido y acogedor para entornos de trabajo relajados",
    "family": "conservative",
    "baseColor": "#f5f5dc",
    "colors": {
      "card": "hsl(0 0% 100%)",
      "ring": "hsl(45 20% 45%)",
      "error": "hsl(0 84% 60%)",
      "input": "hsl(45 15% 91%)",
      "muted": "hsl(45 10% 96%)",
      "paper": "hsl(0 0% 100%)",
      "accent": "hsl(45 15% 90%)",
      "border": "hsl(45 15% 91%)",
      "footer": "hsl(45 10% 96%)",
      "header": "hsl(45 20% 45%)",
      "navbar": "hsl(0 0% 100%)",
      "popover": "hsl(0 0% 100%)",
      "primary": "hsl(45 20% 45%)",
      "success": "hsl(142 76% 36%)",
      "toolbar": "hsl(45 10% 98%)",
      "warning": "hsl(38 92% 50%)",
      "secondary": "hsl(45 10% 96%)",
      "background": "hsl(45 30% 98%)",
      "cardBorder": "hsl(45 15% 91%)",
      "controlsBg": "hsl(45 10% 98%)",
      "foreground": "hsl(45 40% 15%)",
      "cardHoverBg": "hsl(45 10% 98%)",
      "destructive": "hsl(0 84% 60%)",
      "cardForeground": "hsl(45 40% 15%)",
      "cardSelectedBg": "hsl(45 20% 45%)",
      "controlsBorder": "hsl(45 15% 85%)",
      "buttonPrimaryBg": "hsl(45 20% 45%)",
      "mutedForeground": "hsl(45 16% 47%)",
      "attendanceLateBg": "hsl(258 60% 50%)",
      "attendanceLateFg": "hsl(0 0% 100%)",
      "buttonSecondaryBg": "transparent",
      "popoverForeground": "hsl(45 40% 15%)",
      "attendanceAbsentBg": "hsl(0 84% 60%)",
      "attendanceAbsentFg": "hsl(0 0% 100%)",
      "controlsForeground": "hsl(45 40% 15%)",
      "attendancePresentBg": "hsl(45 20% 45%)",
      "attendancePresentFg": "hsl(0 0% 100%)",
      "buttonPrimaryHoverBg": "hsl(45 20% 40%)",
      "attendanceJustifiedBg": "hsl(280 55% 58%)",
      "attendanceJustifiedFg": "hsl(0 0% 100%)",
      "buttonSecondaryBorder": "hsl(45 20% 45%)",
      "destructiveForeground": "hsl(0 0% 100%)",
      "cardSelectedForeground": "hsl(0 0% 100%)",
      "buttonPrimaryForeground": "hsl(0 0% 100%)",
      "attendanceHomeIconDefault": "#b1b4b1",
      "attendanceHomeIconVirtual": "hsl(45 20% 45%)",
      "buttonSecondaryForeground": "hsl(45 20% 45%)",
      "attendanceCheckboxCheckedBg": "hsl(258 60% 50%)"
    },
    "typography": {
      "fontFamily": "Sans-Serif",
      "fontSizeBase": 16,
      "lineHeightBase": "normal"
    }
  },

  {
    "id": "midnight-blue",
    "name": "Midnight Blue",
    "description": "Profundo azul medianoche, elegante y serio para presentaciones corporativas",
    "family": "conservative",
    "baseColor": "#1e40af",
    "colors": {
      "card": "hsl(210 20% 98%)",
      "border": "hsl(210 15% 85%)",
      "navbar": "hsl(210 20% 98%)",
      "primary": "hsl(210 80% 45%)",
      "toolbar": "hsl(210 20% 98%)",
      "secondary": "hsl(210 15% 92%)",
      "background": "hsl(210 25% 96%)",
      "controlsBg": "hsl(210 20% 98%)",
      "foreground": "hsl(222.2 84% 4.9%)",
      "textTertiary": "rgba(90,90,90,0.55)",
      "cardTextColor": "rgba(90,90,90,0.72)",
      "textSecondary": "rgba(90,90,90,0.72)",
      "cardForeground": "hsl(222.2 84% 4.9%)",
      "cardTitleColor": "hsl(222.2 84% 4.9%)",
      "controlsBorder": "hsl(210 15% 80%)",
      "inputForeground": "hsl(222.2 84% 4.9%)",
      "navbarIconColor": "hsl(222.2 84% 4.9%)",
      "tableForeground": "hsl(222.2 84% 4.9%)",
      "attendanceLateBg": "hsl(258 60% 50%)",
      "attendanceLateFg": "hsl(0 0% 100%)",
      "navbarForeground": "#1a1a1a",
      "controlsTextColor": "hsl(222.2 84% 4.9%)",
      "sidebarForeground": "hsl(222.2 84% 4.9%)",
      "attendanceAbsentBg": "hsl(0 84.2% 60.2%)",
      "attendanceAbsentFg": "hsl(0 0% 100%)",
      "controlsForeground": "hsl(222.2 84% 4.9%)",
      "tableRowForeground": "hsl(222.2 84% 4.9%)",
      "attendancePresentBg": "hsl(210 80% 45%)",
      "attendancePresentFg": "hsl(0 0% 100%)",
      "navbarIconHoverColor": "hsl(222.2 84% 4.9%)",
      "navbarItemForeground": "#1a1a1a",
      "attendanceJustifiedBg": "hsl(280 55% 58%)",
      "attendanceJustifiedFg": "hsl(0 0% 100%)",
      "inputPlaceholderColor": "rgba(90,90,90,0.6)",
      "sidebarItemForeground": "hsl(222.2 84% 4.9%)",
      "tableHeaderForeground": "hsl(222.2 84% 4.9%)",
      "rightSidebarForeground": "hsl(222.2 84% 4.9%)",
      "sidebarHeaderForeground": "hsl(222.2 84% 4.9%)",
      "sidebarToggleForeground": "hsl(222.2 84% 4.9%)",
      "attendanceHomeIconDefault": "#b1b4b1",
      "attendanceHomeIconVirtual": "hsl(210 80% 45%)",
      "rightSidebarItemForeground": "hsl(222.2 84% 4.9%)",
      "attendanceCheckboxCheckedBg": "hsl(258 60% 50%)",
      "navbarItemSelectedForeground": "hsl(222.2 84% 4.9%)",
      "rightSidebarHeaderForeground": "hsl(222.2 84% 4.9%)",
      "rightSidebarToggleForeground": "hsl(222.2 84% 4.9%)",
      "rightSidebarHistoryTitleColor": "hsl(222.2 84% 4.9%)",
      "rightSidebarHistoryPreviewColor": "rgba(90,90,90,0.72)",
      "rightSidebarHistoryTimestampColor": "rgba(90,90,90,0.6)"
    },
    "typography": {
      "fontFamily": "Sans-Serif",
      "fontSizeBase": 16,
      "lineHeightBase": "normal"
    }
  },

  {
    "id": "ocean-depths",
    "name": "Ocean Depths",
    "description": "Profesional azul océano profundo, ideal para entornos corporativos y educativos serios",
    "family": "conservative",
    "baseColor": "#1e3a8a",
    "colors": {
      "card": "hsl(210 20% 98%)",
      "border": "hsl(200 15% 85%)",
      "navbar": "hsl(210 20% 98%)",
      "primary": "hsl(195 70% 50%)",
      "toolbar": "hsl(210 20% 98%)",
      "secondary": "hsl(200 15% 92%)",
      "background": "hsl(210 25% 96%)",
      "controlsBg": "hsl(210 20% 98%)",
      "foreground": "hsl(222.2 84% 4.9%)",
      "textTertiary": "rgba(90,90,90,0.55)",
      "cardTextColor": "rgba(90,90,90,0.72)",
      "textSecondary": "rgba(90,90,90,0.72)",
      "cardForeground": "hsl(222.2 84% 4.9%)",
      "cardTitleColor": "hsl(222.2 84% 4.9%)",
      "controlsBorder": "hsl(200 15% 80%)",
      "inputForeground": "hsl(222.2 84% 4.9%)",
      "navbarIconColor": "hsl(222.2 84% 4.9%)",
      "tableForeground": "hsl(222.2 84% 4.9%)",
      "attendanceLateBg": "hsl(258 60% 50%)",
      "attendanceLateFg": "hsl(0 0% 100%)",
      "navbarForeground": "#1a1a1a",
      "controlsTextColor": "hsl(222.2 84% 4.9%)",
      "sidebarForeground": "hsl(222.2 84% 4.9%)",
      "attendanceAbsentBg": "hsl(0 84.2% 60.2%)",
      "attendanceAbsentFg": "hsl(0 0% 100%)",
      "controlsForeground": "hsl(222.2 84% 4.9%)",
      "tableRowForeground": "hsl(222.2 84% 4.9%)",
      "attendancePresentBg": "hsl(195 70% 50%)",
      "attendancePresentFg": "hsl(0 0% 100%)",
      "navbarIconHoverColor": "hsl(222.2 84% 4.9%)",
      "navbarItemForeground": "#1a1a1a",
      "attendanceJustifiedBg": "hsl(280 55% 58%)",
      "attendanceJustifiedFg": "hsl(0 0% 100%)",
      "inputPlaceholderColor": "rgba(90,90,90,0.6)",
      "sidebarItemForeground": "hsl(222.2 84% 4.9%)",
      "tableHeaderForeground": "hsl(222.2 84% 4.9%)",
      "rightSidebarForeground": "hsl(222.2 84% 4.9%)",
      "sidebarHeaderForeground": "hsl(222.2 84% 4.9%)",
      "sidebarToggleForeground": "hsl(222.2 84% 4.9%)",
      "attendanceHomeIconDefault": "#b1b4b1",
      "attendanceHomeIconVirtual": "hsl(195 70% 50%)",
      "rightSidebarItemForeground": "hsl(222.2 84% 4.9%)",
      "attendanceCheckboxCheckedBg": "hsl(258 60% 50%)",
      "navbarItemSelectedForeground": "hsl(222.2 84% 4.9%)",
      "rightSidebarHeaderForeground": "hsl(222.2 84% 4.9%)",
      "rightSidebarToggleForeground": "hsl(222.2 84% 4.9%)",
      "rightSidebarHistoryTitleColor": "hsl(222.2 84% 4.9%)",
      "rightSidebarHistoryPreviewColor": "rgba(90,90,90,0.72)",
      "rightSidebarHistoryTimestampColor": "rgba(90,90,90,0.6)"
    },
    "typography": {
      "fontFamily": "Sans-Serif",
      "fontSizeBase": 16,
      "lineHeightBase": "normal"
    }
  },

  {
    "id": "royal-purple",
    "name": "Royal Purple",
    "description": "Elegante tema púrpura real, sofisticado y profesional para entornos ejecutivos",
    "family": "conservative",
    "baseColor": "#6b21a8",
    "colors": {
      "card": "hsl(260 30% 98%)",
      "border": "hsl(260 20% 85%)",
      "navbar": "hsl(260 30% 98%)",
      "primary": "hsl(260 70% 50%)",
      "toolbar": "hsl(260 30% 98%)",
      "secondary": "hsl(260 20% 92%)",
      "background": "hsl(260 25% 96%)",
      "controlsBg": "hsl(260 30% 98%)",
      "foreground": "hsl(222.2 84% 4.9%)",
      "textTertiary": "rgba(90,90,90,0.55)",
      "cardTextColor": "rgba(90,90,90,0.72)",
      "textSecondary": "rgba(90,90,90,0.72)",
      "cardForeground": "hsl(222.2 84% 4.9%)",
      "cardTitleColor": "hsl(222.2 84% 4.9%)",
      "controlsBorder": "hsl(260 20% 80%)",
      "inputForeground": "hsl(222.2 84% 4.9%)",
      "navbarIconColor": "hsl(222.2 84% 4.9%)",
      "tableForeground": "hsl(222.2 84% 4.9%)",
      "attendanceLateBg": "hsl(258 60% 50%)",
      "attendanceLateFg": "hsl(0 0% 100%)",
      "navbarForeground": "#1a1a1a",
      "controlsTextColor": "hsl(222.2 84% 4.9%)",
      "sidebarForeground": "hsl(222.2 84% 4.9%)",
      "attendanceAbsentBg": "hsl(0 84.2% 60.2%)",
      "attendanceAbsentFg": "hsl(0 0% 100%)",
      "controlsForeground": "hsl(222.2 84% 4.9%)",
      "tableRowForeground": "hsl(222.2 84% 4.9%)",
      "attendancePresentBg": "hsl(260 70% 50%)",
      "attendancePresentFg": "hsl(0 0% 100%)",
      "navbarIconHoverColor": "hsl(222.2 84% 4.9%)",
      "navbarItemForeground": "#1a1a1a",
      "attendanceJustifiedBg": "hsl(280 55% 58%)",
      "attendanceJustifiedFg": "hsl(0 0% 100%)",
      "inputPlaceholderColor": "rgba(90,90,90,0.6)",
      "sidebarItemForeground": "hsl(222.2 84% 4.9%)",
      "tableHeaderForeground": "hsl(222.2 84% 4.9%)",
      "rightSidebarForeground": "hsl(222.2 84% 4.9%)",
      "sidebarHeaderForeground": "hsl(222.2 84% 4.9%)",
      "sidebarToggleForeground": "hsl(222.2 84% 4.9%)",
      "attendanceHomeIconDefault": "#b1b4b1",
      "attendanceHomeIconVirtual": "hsl(260 70% 50%)",
      "rightSidebarItemForeground": "hsl(222.2 84% 4.9%)",
      "attendanceCheckboxCheckedBg": "hsl(258 60% 50%)",
      "navbarItemSelectedForeground": "hsl(222.2 84% 4.9%)",
      "rightSidebarHeaderForeground": "hsl(222.2 84% 4.9%)",
      "rightSidebarToggleForeground": "hsl(222.2 84% 4.9%)",
      "rightSidebarHistoryTitleColor": "hsl(222.2 84% 4.9%)",
      "rightSidebarHistoryPreviewColor": "rgba(90,90,90,0.72)",
      "rightSidebarHistoryTimestampColor": "rgba(90,90,90,0.6)"
    },
    "typography": {
      "fontFamily": "Sans-Serif",
      "fontSizeBase": 16,
      "lineHeightBase": "normal"
    }
  },

  {
    "id": "sage-green",
    "name": "Sage Green",
    "description": "Suave verde salvia, calmante y profesional para entornos de trabajo colaborativo",
    "family": "conservative",
    "baseColor": "#6b7280",
    "colors": {
      "card": "hsl(120 15% 98%)",
      "border": "hsl(120 12% 85%)",
      "navbar": "hsl(120 15% 98%)",
      "primary": "hsl(120 40% 45%)",
      "toolbar": "hsl(120 15% 98%)",
      "secondary": "hsl(120 12% 92%)",
      "background": "hsl(120 15% 96%)",
      "controlsBg": "hsl(120 15% 98%)",
      "foreground": "hsl(222.2 84% 4.9%)",
      "textTertiary": "rgba(90,90,90,0.55)",
      "cardTextColor": "rgba(90,90,90,0.72)",
      "textSecondary": "rgba(90,90,90,0.72)",
      "cardForeground": "hsl(222.2 84% 4.9%)",
      "cardTitleColor": "hsl(222.2 84% 4.9%)",
      "controlsBorder": "hsl(120 12% 80%)",
      "inputForeground": "hsl(222.2 84% 4.9%)",
      "navbarIconColor": "hsl(222.2 84% 4.9%)",
      "tableForeground": "hsl(222.2 84% 4.9%)",
      "attendanceLateBg": "hsl(258 60% 50%)",
      "attendanceLateFg": "hsl(0 0% 100%)",
      "navbarForeground": "#1a1a1a",
      "controlsTextColor": "hsl(222.2 84% 4.9%)",
      "sidebarForeground": "hsl(222.2 84% 4.9%)",
      "attendanceAbsentBg": "hsl(0 84.2% 60.2%)",
      "attendanceAbsentFg": "hsl(0 0% 100%)",
      "controlsForeground": "hsl(222.2 84% 4.9%)",
      "tableRowForeground": "hsl(222.2 84% 4.9%)",
      "attendancePresentBg": "hsl(120 40% 45%)",
      "attendancePresentFg": "hsl(0 0% 100%)",
      "navbarIconHoverColor": "hsl(222.2 84% 4.9%)",
      "navbarItemForeground": "#1a1a1a",
      "attendanceJustifiedBg": "hsl(280 55% 58%)",
      "attendanceJustifiedFg": "hsl(0 0% 100%)",
      "inputPlaceholderColor": "rgba(90,90,90,0.6)",
      "sidebarItemForeground": "hsl(222.2 84% 4.9%)",
      "tableHeaderForeground": "hsl(222.2 84% 4.9%)",
      "rightSidebarForeground": "hsl(222.2 84% 4.9%)",
      "sidebarHeaderForeground": "hsl(222.2 84% 4.9%)",
      "sidebarToggleForeground": "hsl(222.2 84% 4.9%)",
      "attendanceHomeIconDefault": "#b1b4b1",
      "attendanceHomeIconVirtual": "hsl(120 40% 45%)",
      "rightSidebarItemForeground": "hsl(222.2 84% 4.9%)",
      "attendanceCheckboxCheckedBg": "hsl(258 60% 50%)",
      "navbarItemSelectedForeground": "hsl(222.2 84% 4.9%)",
      "rightSidebarHeaderForeground": "hsl(222.2 84% 4.9%)",
      "rightSidebarToggleForeground": "hsl(222.2 84% 4.9%)",
      "rightSidebarHistoryTitleColor": "hsl(222.2 84% 4.9%)",
      "rightSidebarHistoryPreviewColor": "rgba(90,90,90,0.72)",
      "rightSidebarHistoryTimestampColor": "rgba(90,90,90,0.6)"
    },
    "typography": {
      "fontFamily": "Sans-Serif",
      "fontSizeBase": 16,
      "lineHeightBase": "normal"
    }
  },

  {
    "id": "slate-blue",
    "name": "Slate Blue",
    "description": "Azul pizarra equilibrado, versátil y profesional para cualquier entorno de trabajo",
    "family": "conservative",
    "baseColor": "#475569",
    "colors": {
      "card": "hsl(0 0% 100%)",
      "ring": "hsl(215 25% 27%)",
      "error": "hsl(0 84% 60%)",
      "input": "hsl(215 20% 65%)",
      "muted": "hsl(215 20% 65%)",
      "paper": "hsl(0 0% 100%)",
      "accent": "hsl(215 20% 65%)",
      "border": "hsl(215 20% 65%)",
      "footer": "hsl(0 0% 96%)",
      "header": "hsl(215 25% 27%)",
      "navbar": "hsl(0 0% 100%)",
      "popover": "hsl(0 0% 100%)",
      "primary": "hsl(215 25% 27%)",
      "success": "hsl(142 76% 36%)",
      "toolbar": "hsl(215 20% 95%)",
      "warning": "hsl(38 92% 50%)",
      "secondary": "hsl(215 16% 47%)",
      "background": "hsl(0 0% 100%)",
      "cardBorder": "hsl(215 20% 65%)",
      "controlsBg": "hsl(215 20% 97%)",
      "foreground": "hsl(215 25% 27%)",
      "cardHoverBg": "hsl(215 20% 98%)",
      "destructive": "hsl(0 84% 60%)",
      "cardForeground": "hsl(215 25% 27%)",
      "cardSelectedBg": "hsl(215 25% 27%)",
      "controlsBorder": "hsl(215 20% 85%)",
      "buttonPrimaryBg": "hsl(215 25% 27%)",
      "mutedForeground": "hsl(215 16% 47%)",
      "attendanceLateBg": "hsl(258 60% 50%)",
      "attendanceLateFg": "hsl(0 0% 100%)",
      "buttonSecondaryBg": "transparent",
      "popoverForeground": "hsl(215 25% 27%)",
      "attendanceAbsentBg": "hsl(0 84% 60%)",
      "attendanceAbsentFg": "hsl(0 0% 100%)",
      "controlsForeground": "hsl(215 25% 27%)",
      "attendancePresentBg": "hsl(215 25% 27%)",
      "attendancePresentFg": "hsl(0 0% 100%)",
      "buttonPrimaryHoverBg": "hsl(215 25% 22%)",
      "attendanceJustifiedBg": "hsl(280 55% 58%)",
      "attendanceJustifiedFg": "hsl(0 0% 100%)",
      "buttonSecondaryBorder": "hsl(215 25% 27%)",
      "destructiveForeground": "hsl(0 0% 100%)",
      "cardSelectedForeground": "hsl(0 0% 100%)",
      "buttonPrimaryForeground": "hsl(0 0% 100%)",
      "attendanceHomeIconDefault": "#b1b4b1",
      "attendanceHomeIconVirtual": "hsl(215 25% 27%)",
      "buttonSecondaryForeground": "hsl(215 25% 27%)",
      "attendanceCheckboxCheckedBg": "hsl(258 60% 50%)"
    },
    "typography": {
      "fontFamily": "Sans-Serif",
      "fontSizeBase": 16,
      "lineHeightBase": "normal"
    }
  },

  {
    "id": "steel-gray",
    "name": "Steel Gray",
    "description": "Tema gris acero minimalista y moderno, perfecto para interfaces limpias y profesionales",
    "family": "conservative",
    "baseColor": "#475569",
    "colors": {
      "card": "hsl(210 15% 98%)",
      "border": "hsl(210 12% 85%)",
      "navbar": "hsl(210 15% 98%)",
      "primary": "hsl(210 10% 30%)",
      "toolbar": "hsl(210 15% 98%)",
      "secondary": "hsl(210 12% 92%)",
      "background": "hsl(210 15% 96%)",
      "controlsBg": "hsl(210 15% 98%)",
      "foreground": "hsl(222.2 84% 4.9%)",
      "textTertiary": "rgba(90,90,90,0.55)",
      "cardTextColor": "rgba(90,90,90,0.72)",
      "textSecondary": "rgba(90,90,90,0.72)",
      "cardForeground": "hsl(222.2 84% 4.9%)",
      "cardTitleColor": "hsl(222.2 84% 4.9%)",
      "controlsBorder": "hsl(210 12% 80%)",
      "inputForeground": "hsl(222.2 84% 4.9%)",
      "navbarIconColor": "hsl(222.2 84% 4.9%)",
      "tableForeground": "hsl(222.2 84% 4.9%)",
      "attendanceLateBg": "hsl(258 60% 50%)",
      "attendanceLateFg": "hsl(0 0% 100%)",
      "navbarForeground": "#1a1a1a",
      "controlsTextColor": "hsl(222.2 84% 4.9%)",
      "sidebarForeground": "hsl(222.2 84% 4.9%)",
      "attendanceAbsentBg": "hsl(0 84.2% 60.2%)",
      "attendanceAbsentFg": "hsl(0 0% 100%)",
      "controlsForeground": "hsl(222.2 84% 4.9%)",
      "tableRowForeground": "hsl(222.2 84% 4.9%)",
      "attendancePresentBg": "hsl(210 10% 30%)",
      "attendancePresentFg": "hsl(0 0% 100%)",
      "navbarIconHoverColor": "hsl(222.2 84% 4.9%)",
      "navbarItemForeground": "#1a1a1a",
      "attendanceJustifiedBg": "hsl(280 55% 58%)",
      "attendanceJustifiedFg": "hsl(0 0% 100%)",
      "inputPlaceholderColor": "rgba(90,90,90,0.6)",
      "sidebarItemForeground": "hsl(222.2 84% 4.9%)",
      "tableHeaderForeground": "hsl(222.2 84% 4.9%)",
      "rightSidebarForeground": "hsl(222.2 84% 4.9%)",
      "sidebarHeaderForeground": "hsl(222.2 84% 4.9%)",
      "sidebarToggleForeground": "hsl(222.2 84% 4.9%)",
      "attendanceHomeIconDefault": "#b1b4b1",
      "attendanceHomeIconVirtual": "hsl(210 10% 30%)",
      "rightSidebarItemForeground": "hsl(222.2 84% 4.9%)",
      "attendanceCheckboxCheckedBg": "hsl(258 60% 50%)",
      "navbarItemSelectedForeground": "hsl(222.2 84% 4.9%)",
      "rightSidebarHeaderForeground": "hsl(222.2 84% 4.9%)",
      "rightSidebarToggleForeground": "hsl(222.2 84% 4.9%)",
      "rightSidebarHistoryTitleColor": "hsl(222.2 84% 4.9%)",
      "rightSidebarHistoryPreviewColor": "rgba(90,90,90,0.72)",
      "rightSidebarHistoryTimestampColor": "rgba(90,90,90,0.6)"
    },
    "typography": {
      "fontFamily": "Sans-Serif",
      "fontSizeBase": 16,
      "lineHeightBase": "normal"
    }
  },

  {
    "id": "teal-professional",
    "name": "Teal Professional",
    "description": "Moderno teal profesional, fresco y contemporáneo para equipos innovadores",
    "family": "conservative",
    "baseColor": "#0d9488",
    "colors": {
      "card": "hsl(0 0% 100%)",
      "ring": "hsl(173 80% 40%)",
      "error": "hsl(0 84% 60%)",
      "input": "hsl(173 20% 91%)",
      "muted": "hsl(173 20% 96%)",
      "paper": "hsl(0 0% 100%)",
      "accent": "hsl(173 30% 90%)",
      "border": "hsl(173 20% 91%)",
      "footer": "hsl(173 20% 96%)",
      "header": "hsl(173 80% 40%)",
      "navbar": "hsl(0 0% 100%)",
      "popover": "hsl(0 0% 100%)",
      "primary": "hsl(173 80% 40%)",
      "success": "hsl(142 76% 36%)",
      "toolbar": "hsl(173 20% 98%)",
      "warning": "hsl(38 92% 50%)",
      "secondary": "hsl(173 20% 96%)",
      "background": "hsl(0 0% 100%)",
      "cardBorder": "hsl(173 20% 91%)",
      "controlsBg": "hsl(173 20% 98%)",
      "foreground": "hsl(173 40% 15%)",
      "cardHoverBg": "hsl(173 20% 98%)",
      "destructive": "hsl(0 84% 60%)",
      "cardForeground": "hsl(173 40% 15%)",
      "cardSelectedBg": "hsl(173 80% 40%)",
      "controlsBorder": "hsl(173 20% 85%)",
      "buttonPrimaryBg": "hsl(173 80% 40%)",
      "mutedForeground": "hsl(173 16% 47%)",
      "attendanceLateBg": "hsl(258 60% 50%)",
      "attendanceLateFg": "hsl(0 0% 100%)",
      "buttonSecondaryBg": "transparent",
      "popoverForeground": "hsl(173 40% 15%)",
      "attendanceAbsentBg": "hsl(0 84% 60%)",
      "attendanceAbsentFg": "hsl(0 0% 100%)",
      "controlsForeground": "hsl(173 40% 15%)",
      "attendancePresentBg": "hsl(173 80% 40%)",
      "attendancePresentFg": "hsl(0 0% 100%)",
      "buttonPrimaryHoverBg": "hsl(173 80% 35%)",
      "attendanceJustifiedBg": "hsl(280 55% 58%)",
      "attendanceJustifiedFg": "hsl(0 0% 100%)",
      "buttonSecondaryBorder": "hsl(173 80% 40%)",
      "destructiveForeground": "hsl(0 0% 100%)",
      "cardSelectedForeground": "hsl(0 0% 100%)",
      "buttonPrimaryForeground": "hsl(0 0% 100%)",
      "attendanceHomeIconDefault": "#b1b4b1",
      "attendanceHomeIconVirtual": "hsl(173 80% 40%)",
      "buttonSecondaryForeground": "hsl(173 80% 40%)",
      "attendanceCheckboxCheckedBg": "hsl(258 60% 50%)"
    },
    "typography": {
      "fontFamily": "Sans-Serif",
      "fontSizeBase": 16,
      "lineHeightBase": "normal"
    }
  },

  {
    "id": "amber-glow",
    "name": "Amber Glow",
    "description": "Tema oficial: Amber Glow",
    "family": "conservative",
    "baseColor": "#EEB072",
    "colors": {
      "card": "hsl(30 30% 96%)",
      "border": "hsl(30 20% 85%)",
      "navbar": "hsl(30 30% 96%)",
      "primary": "hsl(30 78% 69%)",
      "toolbar": "hsl(30 30% 96%)",
      "secondary": "hsl(30 20% 90%)",
      "background": "hsl(30 30% 92%)",
      "controlsBg": "hsl(30 30% 96%)",
      "foreground": "hsl(30 40% 15%)",
      "textTertiary": "rgba(90,70,60,0.55)",
      "cardTextColor": "rgba(90,70,60,0.72)",
      "textSecondary": "rgba(90,70,60,0.72)",
      "cardForeground": "hsl(30 40% 15%)",
      "cardTitleColor": "hsl(30 40% 15%)",
      "controlsBorder": "hsl(30 20% 80%)",
      "inputForeground": "hsl(30 40% 15%)",
      "navbarIconColor": "hsl(30 40% 15%)",
      "tableForeground": "hsl(30 40% 15%)",
      "attendanceLateBg": "hsl(258 60% 50%)",
      "attendanceLateFg": "hsl(0 0% 100%)",
      "navbarForeground": "hsl(30 40% 15%)",
      "controlsTextColor": "hsl(30 40% 15%)",
      "sidebarForeground": "hsl(30 40% 15%)",
      "attendanceAbsentBg": "hsl(0 84.2% 60.2%)",
      "attendanceAbsentFg": "hsl(0 0% 100%)",
      "controlsForeground": "hsl(30 40% 15%)",
      "tableRowForeground": "hsl(30 40% 15%)",
      "attendancePresentBg": "hsl(30 78% 69%)",
      "attendancePresentFg": "hsl(0 0% 100%)",
      "navbarIconHoverColor": "hsl(30 40% 15%)",
      "navbarItemForeground": "hsl(30 40% 15%)",
      "attendanceJustifiedBg": "hsl(280 55% 58%)",
      "attendanceJustifiedFg": "hsl(0 0% 100%)",
      "inputPlaceholderColor": "rgba(90,70,60,0.6)",
      "sidebarItemForeground": "hsl(30 40% 15%)",
      "tableHeaderForeground": "hsl(30 40% 15%)",
      "rightSidebarForeground": "hsl(30 40% 15%)",
      "sidebarHeaderForeground": "hsl(30 40% 15%)",
      "sidebarToggleForeground": "hsl(30 40% 15%)",
      "attendanceHomeIconDefault": "#b1b4b1",
      "attendanceHomeIconVirtual": "hsl(30 78% 69%)",
      "rightSidebarItemForeground": "hsl(30 40% 15%)",
      "attendanceCheckboxCheckedBg": "hsl(258 60% 50%)",
      "navbarItemSelectedForeground": "hsl(30 40% 15%)",
      "rightSidebarHeaderForeground": "hsl(30 40% 15%)",
      "rightSidebarToggleForeground": "hsl(30 40% 15%)",
      "rightSidebarHistoryTitleColor": "hsl(30 40% 15%)",
      "rightSidebarHistoryPreviewColor": "rgba(90,70,60,0.72)",
      "rightSidebarHistoryTimestampColor": "rgba(90,70,60,0.6)"
    },
    "typography": {
      "fontFamily": "Sans-Serif",
      "fontSizeBase": 16,
      "lineHeightBase": "normal"
    }
  },

  {
    "id": "amber-gold",
    "name": "Amber Gold",
    "description": "Elegante dorado ámbar, sofisticado y cálido para entornos premium",
    "family": "conservative",
    "baseColor": "#d97706",
    "colors": {
      "card": "hsl(45 30% 96%)",
      "border": "hsl(45 20% 85%)",
      "navbar": "hsl(45 30% 96%)",
      "primary": "hsl(45 80% 50%)",
      "toolbar": "hsl(45 30% 96%)",
      "secondary": "hsl(45 20% 90%)",
      "background": "hsl(45 30% 92%)",
      "controlsBg": "hsl(45 30% 96%)",
      "foreground": "hsl(45 40% 15%)",
      "textTertiary": "rgba(95,85,60,0.55)",
      "cardTextColor": "rgba(95,85,60,0.72)",
      "textSecondary": "rgba(95,85,60,0.72)",
      "cardForeground": "hsl(45 40% 15%)",
      "cardTitleColor": "hsl(45 40% 15%)",
      "controlsBorder": "hsl(45 20% 80%)",
      "inputForeground": "hsl(45 40% 15%)",
      "navbarIconColor": "hsl(45 40% 15%)",
      "tableForeground": "hsl(45 40% 15%)",
      "attendanceLateBg": "hsl(258 60% 50%)",
      "attendanceLateFg": "hsl(0 0% 100%)",
      "navbarForeground": "hsl(45 40% 15%)",
      "controlsTextColor": "hsl(45 40% 15%)",
      "sidebarForeground": "hsl(45 40% 15%)",
      "attendanceAbsentBg": "hsl(0 84.2% 60.2%)",
      "attendanceAbsentFg": "hsl(0 0% 100%)",
      "controlsForeground": "hsl(45 40% 15%)",
      "tableRowForeground": "hsl(45 40% 15%)",
      "attendancePresentBg": "hsl(45 80% 50%)",
      "attendancePresentFg": "hsl(0 0% 100%)",
      "navbarIconHoverColor": "hsl(45 40% 15%)",
      "navbarItemForeground": "hsl(45 40% 15%)",
      "attendanceJustifiedBg": "hsl(280 55% 58%)",
      "attendanceJustifiedFg": "hsl(0 0% 100%)",
      "inputPlaceholderColor": "rgba(95,85,60,0.6)",
      "sidebarItemForeground": "hsl(45 40% 15%)",
      "tableHeaderForeground": "hsl(45 40% 15%)",
      "rightSidebarForeground": "hsl(45 40% 15%)",
      "sidebarHeaderForeground": "hsl(45 40% 15%)",
      "sidebarToggleForeground": "hsl(45 40% 15%)",
      "attendanceHomeIconDefault": "#b1b4b1",
      "attendanceHomeIconVirtual": "hsl(45 80% 50%)",
      "rightSidebarItemForeground": "hsl(45 40% 15%)",
      "attendanceCheckboxCheckedBg": "hsl(258 60% 50%)",
      "navbarItemSelectedForeground": "hsl(45 40% 15%)",
      "rightSidebarHeaderForeground": "hsl(45 40% 15%)",
      "rightSidebarToggleForeground": "hsl(45 40% 15%)",
      "rightSidebarHistoryTitleColor": "hsl(45 40% 15%)",
      "rightSidebarHistoryPreviewColor": "rgba(95,85,60,0.72)",
      "rightSidebarHistoryTimestampColor": "rgba(95,85,60,0.6)"
    },
    "typography": {
      "fontFamily": "Sans-Serif",
      "fontSizeBase": 16,
      "lineHeightBase": "normal"
    }
  },

  {
    "id": "back-to-80s",
    "name": "Back To 80s",
    "description": "Tema personalizado: Back To 80s",
    "family": "conservative",
    "baseColor": "#A655F6",
    "colors": {
      "card": "hsl(210 20% 12%)",
      "border": "hsl(270 60% 30%)",
      "navbar": "hsl(210 20% 12%)",
      "primary": "hsl(270 90% 65%)",
      "toolbar": "hsl(210 20% 12%)",
      "secondary": "hsl(270 60% 25%)",
      "sidebarBg": "hsl(210 20% 9%)",
      "background": "hsl(210 15% 8%)",
      "controlsBg": "hsl(210 20% 12%)",
      "foreground": "#ffffff",
      "cardHoverBg": "hsl(210 20% 15%)",
      "cardActiveBg": "hsl(270 28% 18%)",
      "surfaceHover": "hsl(210 20% 15%)",
      "textTertiary": "rgba(255,255,255,0.55)",
      "cardTextColor": "rgba(255,255,255,0.72)",
      "sidebarBorder": "hsl(270 60% 22%)",
      "sidebarItemBg": "transparent",
      "textSecondary": "rgba(255,255,255,0.72)",
      "cardForeground": "#ffffff",
      "cardSelectedBg": "hsl(270 32% 28%)",
      "cardTitleColor": "#ffffff",
      "controlsBorder": "hsl(270 60% 35%)",
      "cardHoverBorder": "hsl(270 60% 30%)",
      "inputForeground": "#ffffff",
      "navbarIconColor": "#ffffff",
      "surfaceSelected": "hsl(270 32% 28%)",
      "tableForeground": "#ffffff",
      "tableRowHoverBg": "hsl(210 20% 15%)",
      "attendanceLateBg": "hsl(258 60% 50%)",
      "attendanceLateFg": "hsl(0 0% 100%)",
      "cardActiveBorder": "hsl(270 38% 38%)",
      "navbarForeground": "#ffffff",
      "buttonSecondaryBg": "transparent",
      "controlsTextColor": "#ffffff",
      "navbarItemHoverBg": "hsl(210 20% 14%)",
      "sidebarForeground": "#ffffff",
      "attendanceAbsentBg": "hsl(0 84.2% 60.2%)",
      "attendanceAbsentFg": "hsl(0 0% 100%)",
      "cardSelectedBorder": "hsl(270 42% 42%)",
      "controlsForeground": "#ffffff",
      "sidebarItemHoverBg": "hsl(210 20% 15%)",
      "tableRowForeground": "#ffffff",
      "tableRowSelectedBg": "hsl(270 32% 28%)",
      "attendancePresentBg": "hsl(270 90% 65%)",
      "attendancePresentFg": "hsl(0 0% 100%)",
      "sidebarItemActiveBg": "hsl(270 28% 18%)",
      "cardActiveForeground": "#ffffff",
      "navbarIconHoverColor": "#ffffff",
      "navbarItemForeground": "#ffffff",
      "attendanceJustifiedBg": "hsl(280 55% 58%)",
      "attendanceJustifiedFg": "hsl(0 0% 100%)",
      "buttonSecondaryBorder": "1px solid #ffffff",
      "inputPlaceholderColor": "rgba(255,255,255,0.6)",
      "sidebarItemForeground": "#ffffff",
      "sidebarItemSelectedBg": "hsl(270 32% 28%)",
      "tableHeaderForeground": "#ffffff",
      "cardSelectedForeground": "hsl(210 40% 98%)",
      "rightSidebarForeground": "#ffffff",
      "sidebarHeaderForeground": "#ffffff",
      "sidebarToggleForeground": "#ffffff",
      "attendanceHomeIconDefault": "#b1b4b1",
      "attendanceHomeIconVirtual": "hsl(270 90% 65%)",
      "attendanceTableRowHoverBg": "hsl(210 20% 15%)",
      "buttonSecondaryForeground": "#ffffff",
      "sidebarItemSelectedBorder": "hsl(270 40% 40%)",
      "surfaceSelectedForeground": "#ffffff",
      "attendanceTableRowActiveBg": "hsl(270 28% 20%)",
      "rightSidebarItemForeground": "#ffffff",
      "sidebarItemHoverForeground": "#ffffff",
      "tableRowSelectedForeground": "hsl(210 40% 98%)",
      "attendanceCheckboxCheckedBg": "hsl(258 60% 50%)",
      "sidebarItemActiveForeground": "#ffffff",
      "attendanceTableRowSelectedBg": "hsl(270 32% 28%)",
      "navbarItemSelectedForeground": "#ffffff",
      "rightSidebarHeaderForeground": "#ffffff",
      "rightSidebarToggleForeground": "#ffffff",
      "attendanceTableRowHoverBorder": "hsl(270 60% 30%)",
      "rightSidebarHistoryTitleColor": "#ffffff",
      "sidebarItemSelectedForeground": "hsl(210 40% 98%)",
      "attendanceTableRowActiveBorder": "hsl(270 90% 65%)",
      "rightSidebarHistoryPreviewColor": "rgba(255,255,255,0.72)",
      "attendanceTableRowSelectedBorder": "hsl(270 90% 50%)",
      "attendanceTableRowHoverForeground": "#ffffff",
      "rightSidebarHistoryTimestampColor": "rgba(255,255,255,0.6)",
      "attendanceTableRowActiveForeground": "#ffffff",
      "attendanceTableRowSelectedForeground": "hsl(210 40% 98%)"
    },
    "typography": {
      "fontFamily": "Sans-Serif",
      "fontSizeBase": 16,
      "lineHeightBase": "normal"
    }
  },

  {
    "id": "burgundy-wine",
    "name": "Burgundy Wine",
    "description": "Profundo vino borgoña, elegante y distinguido para presentaciones ejecutivas",
    "family": "conservative",
    "baseColor": "#7f1d1d",
    "colors": {
      "card": "hsl(350 30% 96%)",
      "border": "hsl(350 20% 85%)",
      "navbar": "hsl(350 30% 96%)",
      "primary": "hsl(350 60% 45%)",
      "toolbar": "hsl(350 30% 96%)",
      "secondary": "hsl(350 20% 90%)",
      "background": "hsl(350 30% 92%)",
      "controlsBg": "hsl(350 30% 96%)",
      "foreground": "hsl(350 40% 15%)",
      "textTertiary": "rgba(90,70,75,0.55)",
      "cardTextColor": "rgba(90,70,75,0.72)",
      "textSecondary": "rgba(90,70,75,0.72)",
      "cardForeground": "hsl(350 40% 15%)",
      "cardTitleColor": "hsl(350 40% 15%)",
      "controlsBorder": "hsl(350 20% 80%)",
      "inputForeground": "hsl(350 40% 15%)",
      "navbarIconColor": "hsl(350 40% 15%)",
      "tableForeground": "hsl(350 40% 15%)",
      "attendanceLateBg": "hsl(258 60% 50%)",
      "attendanceLateFg": "hsl(0 0% 100%)",
      "navbarForeground": "#1a1a1a",
      "controlsTextColor": "hsl(350 40% 15%)",
      "sidebarForeground": "hsl(350 40% 15%)",
      "attendanceAbsentBg": "hsl(0 84.2% 60.2%)",
      "attendanceAbsentFg": "hsl(0 0% 100%)",
      "controlsForeground": "hsl(350 40% 15%)",
      "tableRowForeground": "hsl(350 40% 15%)",
      "attendancePresentBg": "hsl(350 60% 45%)",
      "attendancePresentFg": "hsl(0 0% 100%)",
      "navbarIconHoverColor": "hsl(350 40% 15%)",
      "navbarItemForeground": "#1a1a1a",
      "attendanceJustifiedBg": "hsl(280 55% 58%)",
      "attendanceJustifiedFg": "hsl(0 0% 100%)",
      "inputPlaceholderColor": "rgba(90,70,75,0.6)",
      "sidebarItemForeground": "hsl(350 40% 15%)",
      "tableHeaderForeground": "hsl(350 40% 15%)",
      "rightSidebarForeground": "hsl(350 40% 15%)",
      "sidebarHeaderForeground": "hsl(350 40% 15%)",
      "sidebarToggleForeground": "hsl(350 40% 15%)",
      "attendanceHomeIconDefault": "#b1b4b1",
      "attendanceHomeIconVirtual": "hsl(350 60% 45%)",
      "rightSidebarItemForeground": "hsl(350 40% 15%)",
      "attendanceCheckboxCheckedBg": "hsl(258 60% 50%)",
      "navbarItemSelectedForeground": "hsl(350 40% 15%)",
      "rightSidebarHeaderForeground": "hsl(350 40% 15%)",
      "rightSidebarToggleForeground": "hsl(350 40% 15%)",
      "rightSidebarHistoryTitleColor": "hsl(350 40% 15%)",
      "rightSidebarHistoryPreviewColor": "rgba(90,70,75,0.72)",
      "rightSidebarHistoryTimestampColor": "rgba(90,70,75,0.6)"
    },
    "typography": {
      "fontFamily": "Sans-Serif",
      "fontSizeBase": 16,
      "lineHeightBase": "normal"
    }
  },

  {
    "id": "forest-essence",
    "name": "Forest Essence",
    "description": "Tema verde bosque profesional, perfecto para instituciones educativas y ambientales",
    "family": "conservative",
    "baseColor": "#166534",
    "colors": {
      "card": "hsl(0 0% 100%)",
      "border": "hsl(142 20% 91%)",
      "navbar": "hsl(0 0% 100%)",
      "primary": "hsl(142 76% 36%)",
      "toolbar": "hsl(142 20% 98%)",
      "secondary": "hsl(142 20% 96%)",
      "background": "hsl(0 0% 100%)",
      "controlsBg": "hsl(142 20% 98%)",
      "foreground": "hsl(142 40% 15%)",
      "textTertiary": "rgba(60,60,60,0.55)",
      "cardTextColor": "rgba(60,60,60,0.72)",
      "textSecondary": "rgba(60,60,60,0.72)",
      "cardForeground": "hsl(142 40% 15%)",
      "cardTitleColor": "hsl(142 40% 15%)",
      "controlsBorder": "hsl(142 20% 85%)",
      "inputForeground": "hsl(142 40% 15%)",
      "navbarIconColor": "hsl(142 40% 15%)",
      "tableForeground": "hsl(142 40% 15%)",
      "attendanceLateBg": "hsl(258 60% 50%)",
      "attendanceLateFg": "hsl(0 0% 100%)",
      "navbarForeground": "#1a1a1a",
      "controlsTextColor": "hsl(142 40% 15%)",
      "sidebarForeground": "hsl(142 40% 15%)",
      "attendanceAbsentBg": "hsl(0 84.2% 60.2%)",
      "attendanceAbsentFg": "hsl(0 0% 100%)",
      "controlsForeground": "hsl(142 40% 15%)",
      "tableRowForeground": "hsl(142 40% 15%)",
      "attendancePresentBg": "hsl(142 76% 36%)",
      "attendancePresentFg": "hsl(0 0% 100%)",
      "navbarIconHoverColor": "hsl(142 40% 15%)",
      "navbarItemForeground": "#1a1a1a",
      "attendanceJustifiedBg": "hsl(280 55% 58%)",
      "attendanceJustifiedFg": "hsl(0 0% 100%)",
      "inputPlaceholderColor": "rgba(60,60,60,0.6)",
      "sidebarItemForeground": "hsl(142 40% 15%)",
      "tableHeaderForeground": "hsl(142 40% 15%)",
      "rightSidebarForeground": "hsl(142 40% 15%)",
      "sidebarHeaderForeground": "hsl(142 40% 15%)",
      "sidebarToggleForeground": "hsl(142 40% 15%)",
      "attendanceHomeIconDefault": "#b1b4b1",
      "attendanceHomeIconVirtual": "hsl(142 76% 36%)",
      "rightSidebarItemForeground": "hsl(142 40% 15%)",
      "attendanceCheckboxCheckedBg": "hsl(258 60% 50%)",
      "navbarItemSelectedForeground": "hsl(142 40% 15%)",
      "rightSidebarHeaderForeground": "hsl(142 40% 15%)",
      "rightSidebarToggleForeground": "hsl(142 40% 15%)",
      "rightSidebarHistoryTitleColor": "hsl(142 40% 15%)",
      "rightSidebarHistoryPreviewColor": "rgba(60,60,60,0.72)",
      "rightSidebarHistoryTimestampColor": "rgba(60,60,60,0.6)"
    },
    "typography": {
      "fontFamily": "Sans-Serif",
      "fontSizeBase": 16,
      "lineHeightBase": "normal"
    }
  },

  {
    "id": "ivory-cream",
    "name": "Ivory Cream",
    "description": "Suave marfil crema, cálido y acogedor para entornos de trabajo relajados",
    "family": "conservative",
    "baseColor": "#f5f5dc",
    "colors": {
      "card": "hsl(0 0% 100%)",
      "ring": "hsl(45 20% 45%)",
      "error": "hsl(0 84% 60%)",
      "input": "hsl(45 15% 91%)",
      "muted": "hsl(45 10% 96%)",
      "paper": "hsl(0 0% 100%)",
      "accent": "hsl(45 15% 90%)",
      "border": "hsl(45 15% 91%)",
      "footer": "hsl(45 10% 96%)",
      "header": "hsl(45 20% 45%)",
      "navbar": "hsl(0 0% 100%)",
      "popover": "hsl(0 0% 100%)",
      "primary": "hsl(45 20% 45%)",
      "success": "hsl(142 76% 36%)",
      "toolbar": "hsl(45 10% 98%)",
      "warning": "hsl(38 92% 50%)",
      "secondary": "hsl(45 10% 96%)",
      "background": "hsl(45 30% 98%)",
      "cardBorder": "hsl(45 15% 91%)",
      "controlsBg": "hsl(45 10% 98%)",
      "foreground": "hsl(45 40% 15%)",
      "cardHoverBg": "hsl(45 10% 98%)",
      "destructive": "hsl(0 84% 60%)",
      "cardForeground": "hsl(45 40% 15%)",
      "cardSelectedBg": "hsl(45 20% 45%)",
      "controlsBorder": "hsl(45 15% 85%)",
      "buttonPrimaryBg": "hsl(45 20% 45%)",
      "mutedForeground": "hsl(45 16% 47%)",
      "attendanceLateBg": "hsl(258 60% 50%)",
      "attendanceLateFg": "hsl(0 0% 100%)",
      "buttonSecondaryBg": "transparent",
      "popoverForeground": "hsl(45 40% 15%)",
      "attendanceAbsentBg": "hsl(0 84% 60%)",
      "attendanceAbsentFg": "hsl(0 0% 100%)",
      "controlsForeground": "hsl(45 40% 15%)",
      "attendancePresentBg": "hsl(45 20% 45%)",
      "attendancePresentFg": "hsl(0 0% 100%)",
      "buttonPrimaryHoverBg": "hsl(45 20% 40%)",
      "attendanceJustifiedBg": "hsl(280 55% 58%)",
      "attendanceJustifiedFg": "hsl(0 0% 100%)",
      "buttonSecondaryBorder": "hsl(45 20% 45%)",
      "destructiveForeground": "hsl(0 0% 100%)",
      "cardSelectedForeground": "hsl(0 0% 100%)",
      "buttonPrimaryForeground": "hsl(0 0% 100%)",
      "attendanceHomeIconDefault": "#b1b4b1",
      "attendanceHomeIconVirtual": "hsl(45 20% 45%)",
      "buttonSecondaryForeground": "hsl(45 20% 45%)",
      "attendanceCheckboxCheckedBg": "hsl(258 60% 50%)"
    },
    "typography": {
      "fontFamily": "Sans-Serif",
      "fontSizeBase": 16,
      "lineHeightBase": "normal"
    }
  },

  {
    "id": "midnight-blue",
    "name": "Midnight Blue",
    "description": "Profundo azul medianoche, elegante y serio para presentaciones corporativas",
    "family": "conservative",
    "baseColor": "#1e40af",
    "colors": {
      "card": "hsl(210 20% 98%)",
      "border": "hsl(210 15% 85%)",
      "navbar": "hsl(210 20% 98%)",
      "primary": "hsl(210 80% 45%)",
      "toolbar": "hsl(210 20% 98%)",
      "secondary": "hsl(210 15% 92%)",
      "background": "hsl(210 25% 96%)",
      "controlsBg": "hsl(210 20% 98%)",
      "foreground": "hsl(222.2 84% 4.9%)",
      "textTertiary": "rgba(90,90,90,0.55)",
      "cardTextColor": "rgba(90,90,90,0.72)",
      "textSecondary": "rgba(90,90,90,0.72)",
      "cardForeground": "hsl(222.2 84% 4.9%)",
      "cardTitleColor": "hsl(222.2 84% 4.9%)",
      "controlsBorder": "hsl(210 15% 80%)",
      "inputForeground": "hsl(222.2 84% 4.9%)",
      "navbarIconColor": "hsl(222.2 84% 4.9%)",
      "tableForeground": "hsl(222.2 84% 4.9%)",
      "attendanceLateBg": "hsl(258 60% 50%)",
      "attendanceLateFg": "hsl(0 0% 100%)",
      "navbarForeground": "#1a1a1a",
      "controlsTextColor": "hsl(222.2 84% 4.9%)",
      "sidebarForeground": "hsl(222.2 84% 4.9%)",
      "attendanceAbsentBg": "hsl(0 84.2% 60.2%)",
      "attendanceAbsentFg": "hsl(0 0% 100%)",
      "controlsForeground": "hsl(222.2 84% 4.9%)",
      "tableRowForeground": "hsl(222.2 84% 4.9%)",
      "attendancePresentBg": "hsl(210 80% 45%)",
      "attendancePresentFg": "hsl(0 0% 100%)",
      "navbarIconHoverColor": "hsl(222.2 84% 4.9%)",
      "navbarItemForeground": "#1a1a1a",
      "attendanceJustifiedBg": "hsl(280 55% 58%)",
      "attendanceJustifiedFg": "hsl(0 0% 100%)",
      "inputPlaceholderColor": "rgba(90,90,90,0.6)",
      "sidebarItemForeground": "hsl(222.2 84% 4.9%)",
      "tableHeaderForeground": "hsl(222.2 84% 4.9%)",
      "rightSidebarForeground": "hsl(222.2 84% 4.9%)",
      "sidebarHeaderForeground": "hsl(222.2 84% 4.9%)",
      "sidebarToggleForeground": "hsl(222.2 84% 4.9%)",
      "attendanceHomeIconDefault": "#b1b4b1",
      "attendanceHomeIconVirtual": "hsl(210 80% 45%)",
      "rightSidebarItemForeground": "hsl(222.2 84% 4.9%)",
      "attendanceCheckboxCheckedBg": "hsl(258 60% 50%)",
      "navbarItemSelectedForeground": "hsl(222.2 84% 4.9%)",
      "rightSidebarHeaderForeground": "hsl(222.2 84% 4.9%)",
      "rightSidebarToggleForeground": "hsl(222.2 84% 4.9%)",
      "rightSidebarHistoryTitleColor": "hsl(222.2 84% 4.9%)",
      "rightSidebarHistoryPreviewColor": "rgba(90,90,90,0.72)",
      "rightSidebarHistoryTimestampColor": "rgba(90,90,90,0.6)"
    },
    "typography": {
      "fontFamily": "Sans-Serif",
      "fontSizeBase": 16,
      "lineHeightBase": "normal"
    }
  },

  {
    "id": "ocean-depths",
    "name": "Ocean Depths",
    "description": "Profesional azul océano profundo, ideal para entornos corporativos y educativos serios",
    "family": "conservative",
    "baseColor": "#1e3a8a",
    "colors": {
      "card": "hsl(210 20% 98%)",
      "border": "hsl(200 15% 85%)",
      "navbar": "hsl(210 20% 98%)",
      "primary": "hsl(195 70% 50%)",
      "toolbar": "hsl(210 20% 98%)",
      "secondary": "hsl(200 15% 92%)",
      "background": "hsl(210 25% 96%)",
      "controlsBg": "hsl(210 20% 98%)",
      "foreground": "hsl(222.2 84% 4.9%)",
      "textTertiary": "rgba(90,90,90,0.55)",
      "cardTextColor": "rgba(90,90,90,0.72)",
      "textSecondary": "rgba(90,90,90,0.72)",
      "cardForeground": "hsl(222.2 84% 4.9%)",
      "cardTitleColor": "hsl(222.2 84% 4.9%)",
      "controlsBorder": "hsl(200 15% 80%)",
      "inputForeground": "hsl(222.2 84% 4.9%)",
      "navbarIconColor": "hsl(222.2 84% 4.9%)",
      "tableForeground": "hsl(222.2 84% 4.9%)",
      "attendanceLateBg": "hsl(258 60% 50%)",
      "attendanceLateFg": "hsl(0 0% 100%)",
      "navbarForeground": "#1a1a1a",
      "controlsTextColor": "hsl(222.2 84% 4.9%)",
      "sidebarForeground": "hsl(222.2 84% 4.9%)",
      "attendanceAbsentBg": "hsl(0 84.2% 60.2%)",
      "attendanceAbsentFg": "hsl(0 0% 100%)",
      "controlsForeground": "hsl(222.2 84% 4.9%)",
      "tableRowForeground": "hsl(222.2 84% 4.9%)",
      "attendancePresentBg": "hsl(195 70% 50%)",
      "attendancePresentFg": "hsl(0 0% 100%)",
      "navbarIconHoverColor": "hsl(222.2 84% 4.9%)",
      "navbarItemForeground": "#1a1a1a",
      "attendanceJustifiedBg": "hsl(280 55% 58%)",
      "attendanceJustifiedFg": "hsl(0 0% 100%)",
      "inputPlaceholderColor": "rgba(90,90,90,0.6)",
      "sidebarItemForeground": "hsl(222.2 84% 4.9%)",
      "tableHeaderForeground": "hsl(222.2 84% 4.9%)",
      "rightSidebarForeground": "hsl(222.2 84% 4.9%)",
      "sidebarHeaderForeground": "hsl(222.2 84% 4.9%)",
      "sidebarToggleForeground": "hsl(222.2 84% 4.9%)",
      "attendanceHomeIconDefault": "#b1b4b1",
      "attendanceHomeIconVirtual": "hsl(195 70% 50%)",
      "rightSidebarItemForeground": "hsl(222.2 84% 4.9%)",
      "attendanceCheckboxCheckedBg": "hsl(258 60% 50%)",
      "navbarItemSelectedForeground": "hsl(222.2 84% 4.9%)",
      "rightSidebarHeaderForeground": "hsl(222.2 84% 4.9%)",
      "rightSidebarToggleForeground": "hsl(222.2 84% 4.9%)",
      "rightSidebarHistoryTitleColor": "hsl(222.2 84% 4.9%)",
      "rightSidebarHistoryPreviewColor": "rgba(90,90,90,0.72)",
      "rightSidebarHistoryTimestampColor": "rgba(90,90,90,0.6)"
    },
    "typography": {
      "fontFamily": "Sans-Serif",
      "fontSizeBase": 16,
      "lineHeightBase": "normal"
    }
  },

  {
    "id": "royal-purple",
    "name": "Royal Purple",
    "description": "Elegante tema púrpura real, sofisticado y profesional para entornos ejecutivos",
    "family": "conservative",
    "baseColor": "#6b21a8",
    "colors": {
      "card": "hsl(260 30% 98%)",
      "border": "hsl(260 20% 85%)",
      "navbar": "hsl(260 30% 98%)",
      "primary": "hsl(260 70% 50%)",
      "toolbar": "hsl(260 30% 98%)",
      "secondary": "hsl(260 20% 92%)",
      "background": "hsl(260 25% 96%)",
      "controlsBg": "hsl(260 30% 98%)",
      "foreground": "hsl(222.2 84% 4.9%)",
      "textTertiary": "rgba(90,90,90,0.55)",
      "cardTextColor": "rgba(90,90,90,0.72)",
      "textSecondary": "rgba(90,90,90,0.72)",
      "cardForeground": "hsl(222.2 84% 4.9%)",
      "cardTitleColor": "hsl(222.2 84% 4.9%)",
      "controlsBorder": "hsl(260 20% 80%)",
      "inputForeground": "hsl(222.2 84% 4.9%)",
      "navbarIconColor": "hsl(222.2 84% 4.9%)",
      "tableForeground": "hsl(222.2 84% 4.9%)",
      "attendanceLateBg": "hsl(258 60% 50%)",
      "attendanceLateFg": "hsl(0 0% 100%)",
      "navbarForeground": "#1a1a1a",
      "controlsTextColor": "hsl(222.2 84% 4.9%)",
      "sidebarForeground": "hsl(222.2 84% 4.9%)",
      "attendanceAbsentBg": "hsl(0 84.2% 60.2%)",
      "attendanceAbsentFg": "hsl(0 0% 100%)",
      "controlsForeground": "hsl(222.2 84% 4.9%)",
      "tableRowForeground": "hsl(222.2 84% 4.9%)",
      "attendancePresentBg": "hsl(260 70% 50%)",
      "attendancePresentFg": "hsl(0 0% 100%)",
      "navbarIconHoverColor": "hsl(222.2 84% 4.9%)",
      "navbarItemForeground": "#1a1a1a",
      "attendanceJustifiedBg": "hsl(280 55% 58%)",
      "attendanceJustifiedFg": "hsl(0 0% 100%)",
      "inputPlaceholderColor": "rgba(90,90,90,0.6)",
      "sidebarItemForeground": "hsl(222.2 84% 4.9%)",
      "tableHeaderForeground": "hsl(222.2 84% 4.9%)",
      "rightSidebarForeground": "hsl(222.2 84% 4.9%)",
      "sidebarHeaderForeground": "hsl(222.2 84% 4.9%)",
      "sidebarToggleForeground": "hsl(222.2 84% 4.9%)",
      "attendanceHomeIconDefault": "#b1b4b1",
      "attendanceHomeIconVirtual": "hsl(260 70% 50%)",
      "rightSidebarItemForeground": "hsl(222.2 84% 4.9%)",
      "attendanceCheckboxCheckedBg": "hsl(258 60% 50%)",
      "navbarItemSelectedForeground": "hsl(222.2 84% 4.9%)",
      "rightSidebarHeaderForeground": "hsl(222.2 84% 4.9%)",
      "rightSidebarToggleForeground": "hsl(222.2 84% 4.9%)",
      "rightSidebarHistoryTitleColor": "hsl(222.2 84% 4.9%)",
      "rightSidebarHistoryPreviewColor": "rgba(90,90,90,0.72)",
      "rightSidebarHistoryTimestampColor": "rgba(90,90,90,0.6)"
    },
    "typography": {
      "fontFamily": "Sans-Serif",
      "fontSizeBase": 16,
      "lineHeightBase": "normal"
    }
  },

  {
    "id": "sage-green",
    "name": "Sage Green",
    "description": "Suave verde salvia, calmante y profesional para entornos de trabajo colaborativo",
    "family": "conservative",
    "baseColor": "#6b7280",
    "colors": {
      "card": "hsl(120 15% 98%)",
      "border": "hsl(120 12% 85%)",
      "navbar": "hsl(120 15% 98%)",
      "primary": "hsl(120 40% 45%)",
      "toolbar": "hsl(120 15% 98%)",
      "secondary": "hsl(120 12% 92%)",
      "background": "hsl(120 15% 96%)",
      "controlsBg": "hsl(120 15% 98%)",
      "foreground": "hsl(222.2 84% 4.9%)",
      "textTertiary": "rgba(90,90,90,0.55)",
      "cardTextColor": "rgba(90,90,90,0.72)",
      "textSecondary": "rgba(90,90,90,0.72)",
      "cardForeground": "hsl(222.2 84% 4.9%)",
      "cardTitleColor": "hsl(222.2 84% 4.9%)",
      "controlsBorder": "hsl(120 12% 80%)",
      "inputForeground": "hsl(222.2 84% 4.9%)",
      "navbarIconColor": "hsl(222.2 84% 4.9%)",
      "tableForeground": "hsl(222.2 84% 4.9%)",
      "attendanceLateBg": "hsl(258 60% 50%)",
      "attendanceLateFg": "hsl(0 0% 100%)",
      "navbarForeground": "#1a1a1a",
      "controlsTextColor": "hsl(222.2 84% 4.9%)",
      "sidebarForeground": "hsl(222.2 84% 4.9%)",
      "attendanceAbsentBg": "hsl(0 84.2% 60.2%)",
      "attendanceAbsentFg": "hsl(0 0% 100%)",
      "controlsForeground": "hsl(222.2 84% 4.9%)",
      "tableRowForeground": "hsl(222.2 84% 4.9%)",
      "attendancePresentBg": "hsl(120 40% 45%)",
      "attendancePresentFg": "hsl(0 0% 100%)",
      "navbarIconHoverColor": "hsl(222.2 84% 4.9%)",
      "navbarItemForeground": "#1a1a1a",
      "attendanceJustifiedBg": "hsl(280 55% 58%)",
      "attendanceJustifiedFg": "hsl(0 0% 100%)",
      "inputPlaceholderColor": "rgba(90,90,90,0.6)",
      "sidebarItemForeground": "hsl(222.2 84% 4.9%)",
      "tableHeaderForeground": "hsl(222.2 84% 4.9%)",
      "rightSidebarForeground": "hsl(222.2 84% 4.9%)",
      "sidebarHeaderForeground": "hsl(222.2 84% 4.9%)",
      "sidebarToggleForeground": "hsl(222.2 84% 4.9%)",
      "attendanceHomeIconDefault": "#b1b4b1",
      "attendanceHomeIconVirtual": "hsl(120 40% 45%)",
      "rightSidebarItemForeground": "hsl(222.2 84% 4.9%)",
      "attendanceCheckboxCheckedBg": "hsl(258 60% 50%)",
      "navbarItemSelectedForeground": "hsl(222.2 84% 4.9%)",
      "rightSidebarHeaderForeground": "hsl(222.2 84% 4.9%)",
      "rightSidebarToggleForeground": "hsl(222.2 84% 4.9%)",
      "rightSidebarHistoryTitleColor": "hsl(222.2 84% 4.9%)",
      "rightSidebarHistoryPreviewColor": "rgba(90,90,90,0.72)",
      "rightSidebarHistoryTimestampColor": "rgba(90,90,90,0.6)"
    },
    "typography": {
      "fontFamily": "Sans-Serif",
      "fontSizeBase": 16,
      "lineHeightBase": "normal"
    }
  },

  {
    "id": "slate-blue",
    "name": "Slate Blue",
    "description": "Azul pizarra equilibrado, versátil y profesional para cualquier entorno de trabajo",
    "family": "conservative",
    "baseColor": "#475569",
    "colors": {
      "card": "hsl(0 0% 100%)",
      "ring": "hsl(215 25% 27%)",
      "error": "hsl(0 84% 60%)",
      "input": "hsl(215 20% 65%)",
      "muted": "hsl(215 20% 65%)",
      "paper": "hsl(0 0% 100%)",
      "accent": "hsl(215 20% 65%)",
      "border": "hsl(215 20% 65%)",
      "footer": "hsl(0 0% 96%)",
      "header": "hsl(215 25% 27%)",
      "navbar": "hsl(0 0% 100%)",
      "popover": "hsl(0 0% 100%)",
      "primary": "hsl(215 25% 27%)",
      "success": "hsl(142 76% 36%)",
      "toolbar": "hsl(215 20% 95%)",
      "warning": "hsl(38 92% 50%)",
      "secondary": "hsl(215 16% 47%)",
      "background": "hsl(0 0% 100%)",
      "cardBorder": "hsl(215 20% 65%)",
      "controlsBg": "hsl(215 20% 97%)",
      "foreground": "hsl(215 25% 27%)",
      "cardHoverBg": "hsl(215 20% 98%)",
      "destructive": "hsl(0 84% 60%)",
      "cardForeground": "hsl(215 25% 27%)",
      "cardSelectedBg": "hsl(215 25% 27%)",
      "controlsBorder": "hsl(215 20% 85%)",
      "buttonPrimaryBg": "hsl(215 25% 27%)",
      "mutedForeground": "hsl(215 16% 47%)",
      "attendanceLateBg": "hsl(258 60% 50%)",
      "attendanceLateFg": "hsl(0 0% 100%)",
      "buttonSecondaryBg": "transparent",
      "popoverForeground": "hsl(215 25% 27%)",
      "attendanceAbsentBg": "hsl(0 84% 60%)",
      "attendanceAbsentFg": "hsl(0 0% 100%)",
      "controlsForeground": "hsl(215 25% 27%)",
      "attendancePresentBg": "hsl(215 25% 27%)",
      "attendancePresentFg": "hsl(0 0% 100%)",
      "buttonPrimaryHoverBg": "hsl(215 25% 22%)",
      "attendanceJustifiedBg": "hsl(280 55% 58%)",
      "attendanceJustifiedFg": "hsl(0 0% 100%)",
      "buttonSecondaryBorder": "hsl(215 25% 27%)",
      "destructiveForeground": "hsl(0 0% 100%)",
      "cardSelectedForeground": "hsl(0 0% 100%)",
      "buttonPrimaryForeground": "hsl(0 0% 100%)",
      "attendanceHomeIconDefault": "#b1b4b1",
      "attendanceHomeIconVirtual": "hsl(215 25% 27%)",
      "buttonSecondaryForeground": "hsl(215 25% 27%)",
      "attendanceCheckboxCheckedBg": "hsl(258 60% 50%)"
    },
    "typography": {
      "fontFamily": "Sans-Serif",
      "fontSizeBase": 16,
      "lineHeightBase": "normal"
    }
  },

  {
    "id": "steel-gray",
    "name": "Steel Gray",
    "description": "Tema gris acero minimalista y moderno, perfecto para interfaces limpias y profesionales",
    "family": "conservative",
    "baseColor": "#475569",
    "colors": {
      "card": "hsl(210 15% 98%)",
      "border": "hsl(210 12% 85%)",
      "navbar": "hsl(210 15% 98%)",
      "primary": "hsl(210 10% 30%)",
      "toolbar": "hsl(210 15% 98%)",
      "secondary": "hsl(210 12% 92%)",
      "background": "hsl(210 15% 96%)",
      "controlsBg": "hsl(210 15% 98%)",
      "foreground": "hsl(222.2 84% 4.9%)",
      "textTertiary": "rgba(90,90,90,0.55)",
      "cardTextColor": "rgba(90,90,90,0.72)",
      "textSecondary": "rgba(90,90,90,0.72)",
      "cardForeground": "hsl(222.2 84% 4.9%)",
      "cardTitleColor": "hsl(222.2 84% 4.9%)",
      "controlsBorder": "hsl(210 12% 80%)",
      "inputForeground": "hsl(222.2 84% 4.9%)",
      "navbarIconColor": "hsl(222.2 84% 4.9%)",
      "tableForeground": "hsl(222.2 84% 4.9%)",
      "attendanceLateBg": "hsl(258 60% 50%)",
      "attendanceLateFg": "hsl(0 0% 100%)",
      "navbarForeground": "#1a1a1a",
      "controlsTextColor": "hsl(222.2 84% 4.9%)",
      "sidebarForeground": "hsl(222.2 84% 4.9%)",
      "attendanceAbsentBg": "hsl(0 84.2% 60.2%)",
      "attendanceAbsentFg": "hsl(0 0% 100%)",
      "controlsForeground": "hsl(222.2 84% 4.9%)",
      "tableRowForeground": "hsl(222.2 84% 4.9%)",
      "attendancePresentBg": "hsl(210 10% 30%)",
      "attendancePresentFg": "hsl(0 0% 100%)",
      "navbarIconHoverColor": "hsl(222.2 84% 4.9%)",
      "navbarItemForeground": "#1a1a1a",
      "attendanceJustifiedBg": "hsl(280 55% 58%)",
      "attendanceJustifiedFg": "hsl(0 0% 100%)",
      "inputPlaceholderColor": "rgba(90,90,90,0.6)",
      "sidebarItemForeground": "hsl(222.2 84% 4.9%)",
      "tableHeaderForeground": "hsl(222.2 84% 4.9%)",
      "rightSidebarForeground": "hsl(222.2 84% 4.9%)",
      "sidebarHeaderForeground": "hsl(222.2 84% 4.9%)",
      "sidebarToggleForeground": "hsl(222.2 84% 4.9%)",
      "attendanceHomeIconDefault": "#b1b4b1",
      "attendanceHomeIconVirtual": "hsl(210 10% 30%)",
      "rightSidebarItemForeground": "hsl(222.2 84% 4.9%)",
      "attendanceCheckboxCheckedBg": "hsl(258 60% 50%)",
      "navbarItemSelectedForeground": "hsl(222.2 84% 4.9%)",
      "rightSidebarHeaderForeground": "hsl(222.2 84% 4.9%)",
      "rightSidebarToggleForeground": "hsl(222.2 84% 4.9%)",
      "rightSidebarHistoryTitleColor": "hsl(222.2 84% 4.9%)",
      "rightSidebarHistoryPreviewColor": "rgba(90,90,90,0.72)",
      "rightSidebarHistoryTimestampColor": "rgba(90,90,90,0.6)"
    },
    "typography": {
      "fontFamily": "Sans-Serif",
      "fontSizeBase": 16,
      "lineHeightBase": "normal"
    }
  },

  {
    "id": "teal-professional",
    "name": "Teal Professional",
    "description": "Moderno teal profesional, fresco y contemporáneo para equipos innovadores",
    "family": "conservative",
    "baseColor": "#0d9488",
    "colors": {
      "card": "hsl(0 0% 100%)",
      "ring": "hsl(173 80% 40%)",
      "error": "hsl(0 84% 60%)",
      "input": "hsl(173 20% 91%)",
      "muted": "hsl(173 20% 96%)",
      "paper": "hsl(0 0% 100%)",
      "accent": "hsl(173 30% 90%)",
      "border": "hsl(173 20% 91%)",
      "footer": "hsl(173 20% 96%)",
      "header": "hsl(173 80% 40%)",
      "navbar": "hsl(0 0% 100%)",
      "popover": "hsl(0 0% 100%)",
      "primary": "hsl(173 80% 40%)",
      "success": "hsl(142 76% 36%)",
      "toolbar": "hsl(173 20% 98%)",
      "warning": "hsl(38 92% 50%)",
      "secondary": "hsl(173 20% 96%)",
      "background": "hsl(0 0% 100%)",
      "cardBorder": "hsl(173 20% 91%)",
      "controlsBg": "hsl(173 20% 98%)",
      "foreground": "hsl(173 40% 15%)",
      "cardHoverBg": "hsl(173 20% 98%)",
      "destructive": "hsl(0 84% 60%)",
      "cardForeground": "hsl(173 40% 15%)",
      "cardSelectedBg": "hsl(173 80% 40%)",
      "controlsBorder": "hsl(173 20% 85%)",
      "buttonPrimaryBg": "hsl(173 80% 40%)",
      "mutedForeground": "hsl(173 16% 47%)",
      "attendanceLateBg": "hsl(258 60% 50%)",
      "attendanceLateFg": "hsl(0 0% 100%)",
      "buttonSecondaryBg": "transparent",
      "popoverForeground": "hsl(173 40% 15%)",
      "attendanceAbsentBg": "hsl(0 84% 60%)",
      "attendanceAbsentFg": "hsl(0 0% 100%)",
      "controlsForeground": "hsl(173 40% 15%)",
      "attendancePresentBg": "hsl(173 80% 40%)",
      "attendancePresentFg": "hsl(0 0% 100%)",
      "buttonPrimaryHoverBg": "hsl(173 80% 35%)",
      "attendanceJustifiedBg": "hsl(280 55% 58%)",
      "attendanceJustifiedFg": "hsl(0 0% 100%)",
      "buttonSecondaryBorder": "hsl(173 80% 40%)",
      "destructiveForeground": "hsl(0 0% 100%)",
      "cardSelectedForeground": "hsl(0 0% 100%)",
      "buttonPrimaryForeground": "hsl(0 0% 100%)",
      "attendanceHomeIconDefault": "#b1b4b1",
      "attendanceHomeIconVirtual": "hsl(173 80% 40%)",
      "buttonSecondaryForeground": "hsl(173 80% 40%)",
      "attendanceCheckboxCheckedBg": "hsl(258 60% 50%)"
    },
    "typography": {
      "fontFamily": "Sans-Serif",
      "fontSizeBase": 16,
      "lineHeightBase": "normal"
    }
  },

  {
    "id": "tangerine-dream",
    "name": "Tangerine Dream",
    "description": "Sueño tangerina vibrante que despierta entusiasmo y alegría",
    "family": "playful",
    "baseColor": "#FF8C42",
    "colors": {
      "card": "hsl(28 100% 54%)",
      "paper": "hsl(28 100% 54%)",
      "border": "#000000",
      "navbar": "hsl(28 100% 54%)",
      "popover": "hsl(28 100% 54%)",
      "primary": "hsl(28 100% 54%)",
      "toolbar": "hsl(28 42% 96%)",
      "secondary": "hsl(28 32% 86%)",
      "background": "hsl(28 100% 54%)",
      "cardBorder": "#000000",
      "controlsBg": "hsl(28 100% 54%)",
      "foreground": "hsl(28 35% 16%)",
      "borderFocus": "#000000",
      "borderHover": "#000000",
      "inputBorder": "1px solid #000000",
      "tableBorder": "#000000",
      "navbarBorder": "#000000",
      "textTertiary": "#1a1a1a",
      "cardTextColor": "#1a1a1a",
      "sidebarBorder": "#000000",
      "textSecondary": "#1a1a1a",
      "cardForeground": "hsl(28 35% 16%)",
      "cardTitleColor": "hsl(28 35% 16%)",
      "controlsBorder": "#000000",
      "wbCanvasBorder": "#000000",
      "cardHoverBorder": "#000000",
      "inputForeground": "hsl(28 35% 16%)",
      "navbarIconColor": "hsl(28 35% 16%)",
      "tableCellBorder": "#000000",
      "tableForeground": "hsl(28 35% 16%)",
      "wbToolSetBorder": "#000000",
      "attendanceLateBg": "hsl(258 60% 50%)",
      "attendanceLateFg": "hsl(0 0% 100%)",
      "cardActiveBorder": "#000000",
      "inputFocusBorder": "2px solid #000000",
      "inputHoverBorder": "1px solid #000000",
      "navbarForeground": "hsl(28 35% 16%)",
      "controlsTextColor": "hsl(28 35% 16%)",
      "popoverForeground": "hsl(28 35% 16%)",
      "sidebarForeground": "hsl(28 35% 16%)",
      "attendanceAbsentBg": "hsl(0 84.2% 60.2%)",
      "attendanceAbsentFg": "hsl(0 0% 100%)",
      "cardSelectedBorder": "#000000",
      "controlsForeground": "hsl(28 35% 16%)",
      "tableRowForeground": "hsl(28 35% 16%)",
      "attendancePresentBg": "hsl(28 100% 54%)",
      "attendancePresentFg": "hsl(0 0% 100%)",
      "navbarIconHoverColor": "hsl(28 35% 16%)",
      "navbarItemForeground": "hsl(28 35% 16%)",
      "attendanceJustifiedBg": "hsl(280 55% 58%)",
      "attendanceJustifiedFg": "hsl(0 0% 100%)",
      "buttonSecondaryBorder": "1px solid #000000",
      "inputPlaceholderColor": "rgba(60,40,20,0.6)",
      "sidebarItemForeground": "hsl(28 35% 16%)",
      "tableHeaderForeground": "hsl(28 35% 16%)",
      "rightSidebarForeground": "hsl(28 35% 16%)",
      "sidebarHeaderForeground": "hsl(28 35% 16%)",
      "sidebarToggleForeground": "hsl(28 35% 16%)",
      "attendanceHomeIconDefault": "#b1b4b1",
      "attendanceHomeIconVirtual": "hsl(28 100% 54%)",
      "surfaceSelectedForeground": "hsl(28 35% 16%)",
      "rightSidebarItemForeground": "hsl(28 35% 16%)",
      "attendanceCheckboxCheckedBg": "hsl(258 60% 50%)",
      "navbarItemSelectedForeground": "hsl(28 35% 16%)",
      "rightSidebarHeaderForeground": "hsl(28 35% 16%)",
      "rightSidebarToggleForeground": "hsl(28 35% 16%)",
      "rightSidebarHistoryTitleColor": "hsl(28 35% 16%)",
      "rightSidebarHistoryPreviewColor": "#1a1a1a",
      "rightSidebarHistoryTimestampColor": "rgba(60,40,20,0.6)"
    },
    "typography": {
      "fontFamily": "Sans-Serif",
      "fontSizeBase": 16,
      "lineHeightBase": "normal"
    }
  },

  {
    "id": "tangerine-dream",
    "name": "Tangerine Dream",
    "description": "Sueño tangerina vibrante que despierta entusiasmo y alegría",
    "family": "playful",
    "baseColor": "#FF8C42",
    "colors": {
      "card": "hsl(28 100% 54%)",
      "paper": "hsl(28 100% 54%)",
      "border": "#000000",
      "navbar": "hsl(28 100% 54%)",
      "popover": "hsl(28 100% 54%)",
      "primary": "hsl(28 100% 54%)",
      "toolbar": "hsl(28 42% 96%)",
      "secondary": "hsl(28 32% 86%)",
      "background": "hsl(28 100% 54%)",
      "cardBorder": "#000000",
      "controlsBg": "hsl(28 100% 54%)",
      "foreground": "hsl(28 35% 16%)",
      "borderFocus": "#000000",
      "borderHover": "#000000",
      "inputBorder": "1px solid #000000",
      "tableBorder": "#000000",
      "navbarBorder": "#000000",
      "textTertiary": "#1a1a1a",
      "cardTextColor": "#1a1a1a",
      "sidebarBorder": "#000000",
      "textSecondary": "#1a1a1a",
      "cardForeground": "hsl(28 35% 16%)",
      "cardTitleColor": "hsl(28 35% 16%)",
      "controlsBorder": "#000000",
      "wbCanvasBorder": "#000000",
      "cardHoverBorder": "#000000",
      "inputForeground": "hsl(28 35% 16%)",
      "navbarIconColor": "hsl(28 35% 16%)",
      "tableCellBorder": "#000000",
      "tableForeground": "hsl(28 35% 16%)",
      "wbToolSetBorder": "#000000",
      "attendanceLateBg": "hsl(258 60% 50%)",
      "attendanceLateFg": "hsl(0 0% 100%)",
      "cardActiveBorder": "#000000",
      "inputFocusBorder": "2px solid #000000",
      "inputHoverBorder": "1px solid #000000",
      "navbarForeground": "hsl(28 35% 16%)",
      "controlsTextColor": "hsl(28 35% 16%)",
      "popoverForeground": "hsl(28 35% 16%)",
      "sidebarForeground": "hsl(28 35% 16%)",
      "attendanceAbsentBg": "hsl(0 84.2% 60.2%)",
      "attendanceAbsentFg": "hsl(0 0% 100%)",
      "cardSelectedBorder": "#000000",
      "controlsForeground": "hsl(28 35% 16%)",
      "tableRowForeground": "hsl(28 35% 16%)",
      "attendancePresentBg": "hsl(28 100% 54%)",
      "attendancePresentFg": "hsl(0 0% 100%)",
      "navbarIconHoverColor": "hsl(28 35% 16%)",
      "navbarItemForeground": "hsl(28 35% 16%)",
      "attendanceJustifiedBg": "hsl(280 55% 58%)",
      "attendanceJustifiedFg": "hsl(0 0% 100%)",
      "buttonSecondaryBorder": "1px solid #000000",
      "inputPlaceholderColor": "rgba(60,40,20,0.6)",
      "sidebarItemForeground": "hsl(28 35% 16%)",
      "tableHeaderForeground": "hsl(28 35% 16%)",
      "rightSidebarForeground": "hsl(28 35% 16%)",
      "sidebarHeaderForeground": "hsl(28 35% 16%)",
      "sidebarToggleForeground": "hsl(28 35% 16%)",
      "attendanceHomeIconDefault": "#b1b4b1",
      "attendanceHomeIconVirtual": "hsl(28 100% 54%)",
      "surfaceSelectedForeground": "hsl(28 35% 16%)",
      "rightSidebarItemForeground": "hsl(28 35% 16%)",
      "attendanceCheckboxCheckedBg": "hsl(258 60% 50%)",
      "navbarItemSelectedForeground": "hsl(28 35% 16%)",
      "rightSidebarHeaderForeground": "hsl(28 35% 16%)",
      "rightSidebarToggleForeground": "hsl(28 35% 16%)",
      "rightSidebarHistoryTitleColor": "hsl(28 35% 16%)",
      "rightSidebarHistoryPreviewColor": "#1a1a1a",
      "rightSidebarHistoryTimestampColor": "rgba(60,40,20,0.6)"
    },
    "typography": {
      "fontFamily": "Sans-Serif",
      "fontSizeBase": 16,
      "lineHeightBase": "normal"
    }
  },

  // <BUNDLE_INSERT_MARKER> — nuevos temas oficiales: insertar objetos **antes** de esta línea (ACV-Backend/scripts/create-theme-and-bundle.js)
];

// Función helper para añadir tipografía por defecto a temas que no la tengan
const addDefaultTypography = (theme) => {
  if (!theme.typography) {
    theme.typography = {
      fontFamily: "Sans-Serif",
      fontSizeBase: 14,
      lineHeightBase: "normal",
      letterSpacingBase: "normal",
    };
  }
  return theme;
};

// Función helper para añadir formato de tabla por defecto a temas que no lo tengan
const addDefaultTableFormat = (theme) => {
  if (!theme.tableFormat) {
    theme.tableFormat = "uniform"; // Por defecto: todas las filas iguales
  }
  return theme;
};

// Aplicar tipografía y formato de tabla por defecto a todos los temas
themeColorOptions.forEach(addDefaultTypography);
themeColorOptions.forEach(addDefaultTableFormat);

export const getThemesByFamily = (family) => {
  return themeColorOptions.filter((theme) => theme.family === family);
};

export const getDefaultThemeForFamily = (family) => {
  if (family === "conservative") {
    return themeColorOptions.find((theme) => theme.id === "default") || themeColorOptions[0];
  }
  if (family === "accessibility") {
    return themeColorOptions.find((theme) => theme.id === "high-contrast-light") || themeColorOptions[0];
  }
  return themeColorOptions.find((theme) => theme.family === "playful") || themeColorOptions[6];
};

export const isDefaultTheme = (themeId) => {
  return themeId === "default" || themeId === "default-dark";
};

// Obtener los IDs de los temas base originales (los 18 predefinidos)
export const getBaseThemeIds = () => {
  // Los temas base son todos los que están en themeColorOptions originales
  // y que no tienen family === "custom"
  return themeColorOptions
    .filter((theme) => theme.family !== "custom")
    .map((theme) => theme.id);
};

// Verificar si un tema es base (no se puede modificar directamente)
export const isBaseTheme = (themeId) => {
  const baseThemeIds = getBaseThemeIds();
  return baseThemeIds.includes(themeId);
};

/** Límite de la columna id en acvapp.acvplans.themes (varchar(50)). */
export const THEME_ID_MAX_LENGTH = 50;

/**
 * Genera un id para tema personalizado (copia) que cumple varchar(50).
 * Formato: custom-{baseId}-{últimos 8 dígitos de timestamp}.
 */
export function customThemeId(baseId) {
  const suffix = '-' + Date.now().toString().slice(-8);
  const safeBase = String(baseId || 'theme').replace(/[^a-z0-9-]/gi, '').slice(0, 34);
  const full = 'custom-' + safeBase + suffix;
  return full.length > THEME_ID_MAX_LENGTH ? full.slice(0, THEME_ID_MAX_LENGTH) : full;
}

/**
 * Asegura que un id de tema no exceda 50 caracteres (límite de BD).
 */
export function ensureThemeIdMax50(id) {
  if (typeof id !== 'string') return id;
  return id.length > THEME_ID_MAX_LENGTH ? id.slice(0, THEME_ID_MAX_LENGTH) : id;
}

export const getThemeById = (themeId) => {
  return themeColorOptions.find((theme) => theme.id === themeId) || themeColorOptions[0];
};

/**
 * Copia profunda de un tema **oficial** embebido en el bundle (conservative, playful, accessibility).
 * Los temas `family === 'custom'` (incluso si están en themeColorOptions por localStorage) devuelven
 * `null` para forzar resolución vía API / payload remoto.
 */
export function getBundledOfficialThemeById(themeId) {
  if (!themeId || typeof themeId !== 'string') return null;
  const t = themeColorOptions.find((opt) => opt.id === themeId);
  if (!t || t.family === 'custom') return null;
  try {
    return JSON.parse(JSON.stringify(t));
  } catch {
    return {
      ...t,
      colors: t.colors ? { ...t.colors } : {},
      typography: t.typography ? { ...t.typography } : undefined,
    };
  }
}

/**
 * Lee themeId por módulo desde localStorage (acv-module-themes + moduleThemes legacy), sin API.
 */
export function getModuleThemeIdFromLocalStorageSync(moduleCandidateIds) {
  if (typeof window === 'undefined' || typeof localStorage === 'undefined') {
    return null;
  }
  let merged = {};
  try {
    const acv = JSON.parse(localStorage.getItem('acv-module-themes') || '{}');
    const legacy = JSON.parse(localStorage.getItem('moduleThemes') || '{}');
    merged = { ...legacy, ...acv };
  } catch (e) {
    return null;
  }
  const ids = Array.isArray(moduleCandidateIds) ? moduleCandidateIds : [moduleCandidateIds];
  for (const mid of ids) {
    if (merged[mid]) return merged[mid];
  }
  return null;
}

/**
 * Tras un GET config "light" (sin colors en oficiales), rellena tokens desde el bundle local.
 * Si la BD devuelve tokens extendidos parciales (p. ej. solo los que difieren del bundle),
 * se hace un merge donde el bundle pone la base y la BD sobreescribe los tokens extendidos.
 */
export function hydrateAvailableThemesFromBundle(availableThemes) {
  if (!Array.isArray(availableThemes)) return availableThemes;
  return availableThemes.map((t) => {
    if (!t || !t.id) return t;
    if (t.family === 'custom') return t;
    const bundled = getBundledOfficialThemeById(t.id);
    if (!bundled) return t;
    const dbColors = (t.colors && typeof t.colors === 'object') ? t.colors : {};
    const hasDbColors = Object.keys(dbColors).length > 0;
    return {
      ...bundled,
      ...t,
      name: t.name ?? bundled.name,
      description: t.description ?? bundled.description,
      // Bundle como base; tokens extendidos de BD ganan si existen.
      // Esto preserva cardBorder, card=background, border monocromático, etc.
      colors: hasDbColors
        ? { ...bundled.colors, ...dbColors }
        : bundled.colors,
      typography: bundled.typography ?? t.typography,
    };
  });
}

// Cargar temas personalizados desde localStorage
export const loadCustomThemes = () => {
  if (typeof window === 'undefined' || typeof localStorage === 'undefined') {
    return [];
  }
  try {
    const stored = localStorage.getItem('acv-custom-themes');
    if (stored) {
      const customThemes = JSON.parse(stored);
      console.log('[themeColors] Loading custom themes from localStorage:', customThemes);
      // Agregar temas personalizados a themeColorOptions si no existen
      customThemes.forEach((theme) => {
        if (!themeColorOptions.find((t) => t.id === theme.id)) {
          // Asegurar que el tema tenga family: "custom"
          if (!theme.family) {
            theme.family = "custom";
          }
          themeColorOptions.push(theme);
          console.log('[themeColors] Added custom theme:', theme.id, theme.name);
        }
      });
      return customThemes;
    } else {
      console.log('[themeColors] No custom themes found in localStorage');
    }
  } catch (error) {
    console.error('Error loading custom themes:', error);
  }
  return [];
};

// Guardar temas personalizados en localStorage
const saveCustomThemes = () => {
  try {
    const customThemes = themeColorOptions.filter((theme) => theme.family === "custom");
    console.log('[themeColors] Saving custom themes to localStorage:', customThemes.length, 'themes');
    localStorage.setItem('acv-custom-themes', JSON.stringify(customThemes));
  } catch (error) {
    console.error('Error saving custom themes:', error);
  }
};

export const addTheme = (theme) => {
  if (!themeColorOptions.find((t) => t.id === theme.id)) {
    themeColorOptions.push(theme);
    // Guardar en localStorage si es un tema personalizado
    if (theme.family === "custom") {
      saveCustomThemes();
    }
  }
};

export const removeTheme = (themeId) => {
  // No permitir eliminar temas base
  if (isBaseTheme(themeId)) {
    return false;
  }

  const index = themeColorOptions.findIndex((t) => t.id === themeId);
  if (index >= 0) {
    themeColorOptions.splice(index, 1);
    // Actualizar localStorage
    saveCustomThemes();
    return true;
  }
  return false;
};

// Cargar temas personalizados al inicializar (solo cliente; evita ReferenceError en SSR/Next build)
if (typeof window !== 'undefined' && typeof localStorage !== 'undefined') {
  loadCustomThemes();
}

// ===== SISTEMA DE PERSISTENCIA POR MÓDULO =====

// Función para guardar qué tema tiene cada módulo
export const saveModuleThemes = (moduleThemes) => {
  try {
    localStorage.setItem('acv-module-themes', JSON.stringify(moduleThemes));
    console.log('[Module Themes] Saved:', moduleThemes);
  } catch (error) {
    console.error('[Module Themes] Error saving:', error);
  }
};

// Función para cargar temas por módulo
export const loadModuleThemes = () => {
  try {
    const stored = localStorage.getItem('acv-module-themes');
    if (stored) {
      const moduleThemes = JSON.parse(stored);
      console.log('[Module Themes] Loaded:', moduleThemes);
      return moduleThemes;
    }
  } catch (error) {
    console.error('[Module Themes] Error loading:', error);
  }

  // Retornar configuración por defecto
  return {
    attendance: null,
    assignment: null,
    whiteboard: null,
    charts: null,
    navigation: null,
    studentProgress: null,
  };
};

/**
 * Obtiene el slug del tenant activo desde las fuentes habituales
 * (window.msg, userinfo, localStorage) sin depender de themesApi.js.
 * Retorna null si no está disponible.
 */
function resolveCurrentTenantSlug() {
  try {
    if (typeof window === 'undefined') return null;
    if (window.msg?.user?.slug)
      return String(window.msg.user.slug).replace(/^\?slug=/, '') || null;
    const ui = JSON.parse(localStorage.getItem('userinfo') || 'null');
    if (ui?.slug) return String(ui.slug).replace(/^\?slug=/, '') || null;
    if (ui?.database) return String(ui.database).replace(/^\?slug=/, '') || null;
    const s = localStorage.getItem('slug');
    if (s) return String(s).replace(/^\?slug=/, '') || null;
  } catch { /* ignorar */ }
  return null;
}

/**
 * Guarda el objeto completo del tema en un mapa indexado por módulo.
 * Permite que la aplicación granular (eye icon por módulos) persista correctamente
 * incluso cuando distintos módulos tienen temas distintos.
 *
 * @param {Object} theme         - Objeto de tema completo con id, colors, etc.
 * @param {string[]|null} moduleIds  - Lista de módulos afectados. Si null → se guarda bajo '*' (global).
 */
export const saveThemeObjectToStorage = (theme, moduleIds = null) => {
  if (!theme || !theme.id) return;
  try {
    const tenantSlug = resolveCurrentTenantSlug();
    const raw = localStorage.getItem('acv-module-theme-objects');
    const map = raw ? JSON.parse(raw) : {};

    const payload = { ...theme, _tenantSlug: tenantSlug };

    if (!moduleIds || moduleIds.length === 0) {
      // Sin lista de módulos: guardar como global ('*')
      map['*'] = payload;
    } else {
      // Guardar para cada módulo afectado
      moduleIds.forEach(mid => { map[mid] = payload; });
    }

    localStorage.setItem('acv-module-theme-objects', JSON.stringify(map));
  } catch (e) {
    console.warn('[Module Themes] Error saving theme object map:', e);
  }
};

/**
 * Lee el objeto de tema para un módulo concreto desde el mapa por módulo.
 * Orden: módulo específico → global ('*') → null.
 * Descarta si el slug del tenant no coincide.
 *
 * @param {string[]} moduleCandidates - IDs de módulo a buscar (ej. ['navigation']).
 * @returns {Object|null}
 */
export const loadThemeObjectFromStorage = (moduleCandidates) => {
  try {
    const raw = localStorage.getItem('acv-module-theme-objects');
    if (!raw) return null;
    const map = JSON.parse(raw);
    const slug = resolveCurrentTenantSlug();

    const candidates = Array.isArray(moduleCandidates)
      ? [...moduleCandidates, '*']
      : ['*'];

    for (const mid of candidates) {
      const obj = map[mid];
      if (!obj || !obj.id || !obj.colors) continue;

      // Validar slug
      if (obj._tenantSlug && slug && obj._tenantSlug !== slug) {
        console.warn('[Module Themes] ⚠️ Objeto de tema descartado por slug distinto:', {
          module: mid, savedSlug: obj._tenantSlug, currentSlug: slug,
        });
        // Limpiar la entrada inválida
        delete map[mid];
        try { localStorage.setItem('acv-module-theme-objects', JSON.stringify(map)); } catch { /* ignore */ }
        continue;
      }

      return obj;
    }
    return null;
  } catch (e) {
    return null;
  }
};

/**
 * Limpia las claves de tema en localStorage al hacer logout.
 * Llamar antes de redirigir a la pantalla de autenticación.
 */
export const clearThemeStorage = () => {
  try {
    localStorage.removeItem('acv-module-theme-objects');
    localStorage.removeItem('acv-active-theme-object'); // legacy key
    localStorage.removeItem('acv-module-themes');
    localStorage.removeItem('moduleThemes');
  } catch (e) { /* ignorar */ }
};

// Función para aplicar tema a módulos específicos
export const applyThemeToModules = (theme, selectedExtensions, applyToAll = false) => {
  const moduleThemes = loadModuleThemes();
  const exts = Array.isArray(selectedExtensions) ? selectedExtensions : [];

  if (applyToAll) {
    // Aplicar a "todas": usar la lista explícita pasada (p. ej. todos los ids de availableExtensions).
    // Antes solo se iteraba Object.keys(moduleThemes) y el objeto por defecto no incluía FEB
    // (feedback, events, booking) → el clic simple no guardaba tema para esos módulos en localStorage.
    const targetIds = exts.length > 0 ? exts : Object.keys(moduleThemes);
    targetIds.forEach((moduleId) => {
      moduleThemes[moduleId] = theme.id;
    });
  } else {
    exts.forEach((extensionId) => {
      moduleThemes[extensionId] = theme.id;
    });
  }

  saveModuleThemes(moduleThemes);

  // Persistir el objeto completo indexado por módulo para que el hard refresh recupere
  // los tokens extendidos (BD) sin pisar con la versión simplificada del bundle.
  // Pasar los módulos afectados para soportar aplicación granular (E3).
  const affectedModules = applyToAll
    ? (exts.length > 0 ? exts : Object.keys(moduleThemes))
    : exts;
  saveThemeObjectToStorage(theme, affectedModules);

  console.log('[Module Themes] Applied theme:', {
    themeId: theme.id,
    themeName: theme.name,
    applyToAll,
    selectedExtensions,
    newConfig: moduleThemes
  });

  return moduleThemes;
};

// Función para obtener el tema de un módulo específico
export const getModuleTheme = (moduleId) => {
  const moduleThemes = loadModuleThemes();
  const themeId = moduleThemes[moduleId];

  if (themeId) {
    return themeColorOptions.find(theme => theme.id === themeId);
  }

  return null;
};

// Función para obtener todos los temas por módulo
export const getAllModuleThemes = () => {
  return loadModuleThemes();
};
